/** Claves i18n compartidas para dashboard, paneles y apariencia (ES = fallback en componentes). */
export const DASHBOARD_I18N_ES = {
  'nav.masters': 'Maestros',
  'nav.audit': 'Auditoría',
  'nav.appearance': 'Apariencia',
  'nav.paymentlinks': 'Pagos',
  'nav.liveclasses': 'Clases en Vivo',
  'nav.myplan': 'Mi Plan',
  'nav.training': 'Entrenamiento',
  'nav.companies': 'Empresas',
  'nav.mybrand': 'Mi marca',
  'nav.programs_d28d': 'Fit Live · Programas',
  'nav.gallery': 'Galería',
  'nav.gallery_classes': 'GRABACIONES DE CLASE',
  'nav.gallery_exercises': 'Biblioteca ejercicios',
  'nav.routines': 'Rutinas',
  'nav.routine_templates': 'Rutinas',
  'nav.planning': 'Planificación',
  'nav.tracking': 'Seguimiento',
  'nav.coach_ai': 'Asistente IA',
  'nav.assign_plans': 'Asignar planes',
  'nav.edit_routines': 'Editar rutinas',
  'coach.routines.title': 'Editar rutinas',
  'coach.routines.subtitle': 'Crea rutinas (biblioteca), asígnalas a tus clientes y edita las ya asignadas. En cada día puedes elegir Gimnasio o Deportes (Running / Natación).',
  'coach.routines.assigned_heading': 'Rutinas asignadas',
  'coach.routines.library_tab': 'Rutinas',
  'coach.routines.search_ph': 'Buscar por cliente, ID o nivel…',
  'coach.routines.empty_title': 'Aún no hay rutinas asignadas',
  'coach.routines.empty_body': 'Crea una rutina en la pestaña Rutinas (o usa Asistente IA) y asígnala a un cliente. Después podrás editarla aquí.',
  'coach.routines.go_ai': 'Ir a Asistente IA',
  'coach.routines.go_clients': 'Ver mis usuarios',
  'coach.routines.go_activate': 'Activar clientes',
  'coach.routines.editor_hint': 'Elige «Editar» en Rutinas o en Rutinas asignadas.',
  'coach.routines.sport_hint': 'Cada día es independiente: gimnasio, Running o Natación. Añadir días no borra los que ya existen; puedes sumar ejercicios de gym o de deporte y eliminar el día si hace falta.',
  'nav.trainers_admin': 'Entrenadores',
  'nav.coach_users': 'Usuarios coaches',
  'panel.back_panel': '← Panel',
  'nav.myusers': 'Mis usuarios',
  'nav.nutrition_plans': 'Planes nutricionales',
  'nav.foods_catalog': 'Alimentos',
  'nav.vigencias': 'Vigencias',
  'nav.assistant': 'Asistente',
  'nav.liveclasses_short': 'Clases',
  'nav.plans_short': 'Planes',
  'nav.gyms': 'Gimnasios',
  'nav.tenants': 'Tenants',
  'nav.mi_progreso': 'Mi Progreso',
  'nav.support': 'Soporte',
  'nav.services': 'Servicios',
  'nav.tracking_training': 'Seguimiento entreno',
  'nav.tracking_food': 'Seguimiento food',
  'nav.host_daily': 'Mi día',
  'nav.organizations': 'Organizaciones',
  'nav.commercial_plans': 'Planes comerciales',
  'nav.spiritual': 'Viento Recio',
  'nav.photos_measurements': 'Fotos y medidas',
  'nav.activate_clients': 'Activar clientes',
  'nav.training_pending': 'Training pendientes',

  'status.activo': 'Activo',
  'status.vigente': 'Vigente',
  'status.por_vencer': 'Por vencer',
  'status.pendiente': 'Pendiente',
  'status.pendiente_sede': 'Pago en sede pendiente',
  'status.pendiente_pago_online': 'Pago en línea pendiente',
  'status.vencido': 'Vencido',
  'status.cancelado': 'Cancelado',
  'status.en_proceso': 'En proceso',
  'status.rechazado': 'Rechazado',
  'status.active': 'Activo',
  'status.published': 'Publicado',

  'service.d28d': 'Fit Live · Programa',
  'service.food': 'FOOD PLAN',
  'service.training': 'TRAINING',

  'payment.wompi_online': 'Pago en línea (Wompi)',
  'payment.pago_sede': 'Pago en sede',
  'payment.pago_pendiente': 'Pago pendiente (activar manual)',

  'myaccount.profile': 'Mi Perfil',
  'myaccount.my_services': 'Mis Servicios',
  'myaccount.my_coach': 'Mi entrenador',
  'myaccount.acquire_food': 'Adquirir FOOD PLAN',
  'myaccount.acquire_services': 'Adquirir otros servicios',
  'myaccount.food_not_contracted': 'Aún no tienes FOOD PLAN. Contrátalo aquí para registrar tu alimentación con tu coach.',
  'myaccount.food_pending_title': 'FOOD PLAN pendiente de pago',
  'myaccount.food_pending_hint': 'Tu solicitud está registrada. Completa el pago en línea (Wompi) o espera la confirmación de tu coach para activar FOOD PLAN.',
  'myaccount.food_active_title': 'FOOD PLAN activo',
  'myaccount.food_active_hint': 'Tu plan nutricional está vigente. Ábrelo desde Inicio o Mi Progreso → Alimentación.',
  'myaccount.plan_duration': 'Vigencia',
  'myaccount.plan_duration_days': '{days} días calendario',
  'myaccount.food_plans': 'Planes FOOD disponibles',
  'myaccount.program': 'Programa',
  'myaccount.plan_label': 'Plan',
  'myaccount.start_date': 'Inicio',
  'myaccount.cycle_d28d': 'Ciclo Fit Live · Programa',
  'myaccount.none_trainer': 'Ninguno',
  'myaccount.weight': 'Peso (kg)',
  'myaccount.height': 'Altura (cm)',
  'myaccount.objective_maintenance': 'Mantenimiento',
  'myaccount.objective_fatloss': 'Pérdida de Grasa',
  'myaccount.objective_muscle': 'Ganancia Muscular',
  'myaccount.per_month': '/ mes',
  'myaccount.couple_plan': 'Plan de pareja — incluye código para 2.ª persona',
  'myaccount.plan_hint': 'Puedes elegir gimnasio, entrenador, ambos o ninguno. Solo el plan es obligatorio.',
  'myaccount.cycle_select': 'Ciclo Fit Live · Programa',
  'myaccount.cycle_select_ph': 'Selecciona ciclo',
  'myaccount.gym_optional': 'Gimnasio (opcional)',
  'myaccount.trainer_optional': 'Entrenador (opcional)',
  'myaccount.couple_code_title': 'Código para tu pareja (un solo uso)',
  'myaccount.copy_code': 'Copiar código',
  'myaccount.couple_code_hint': 'Compártelo en el registro; heredará plan, programa y vigencia.',
  'myaccount.linked_account': 'Cuenta vinculada a plan de pareja (invitado).',
  'myaccount.whatsapp_support': 'WhatsApp soporte',
  'myaccount.toast.copied': 'Copiado',
  'myaccount.toast.couple_copied': 'Código de pareja copiado al portapapeles',
  'myaccount.toast.copy_manual': 'Copia el código manualmente',
  'myaccount.toast.sub_active': 'Suscripción activada',
  'myaccount.toast.plan_active': 'Plan {plan} activo',
  'myaccount.toast.pending': 'Solicitud registrada',
  'myaccount.toast.success': 'Suscripción exitosa',
  'myaccount.toast.pending_msg': 'Tu coach o administrador confirmará el pago en sede, o completa Wompi en la pestaña abierta.',
  'myaccount.toast.plan_activated': 'Plan {plan} activado',
  'myaccount.toast.profile_ok': 'Perfil actualizado',
  'myaccount.toast.profile_saved': 'Tus datos fueron guardados',
  'myaccount.toast.profile_error': 'No se pudo actualizar el perfil',
  'myaccount.toast.subscribe_error': 'Error al suscribirse',

  'common.current': 'Tu Plan Actual',
  'common.roles': 'Permisos',

  'mi_progreso.subtitle': 'Tu avance en nutrición, entrenamiento y Fit Live · Programa en un solo lugar.',
  'mi_progreso.subtitle_d28d': 'Tu avance, clases en vivo e inscripciones en un solo lugar.',
  'mi_progreso.subtitle_coach': 'Tu avance en nutrición y entrenamiento con {brand}.',
  'mi_progreso.subtitle_training_brand': 'Tu rutina, medidas y progreso con {brand}.',
  'mi_progreso.your_coach': 'tu entrenador',
  'mi_progreso.tab.pruebas_fitness': 'Pruebas fitness',
  'mi_progreso.food_external_hint': 'Tu registro nutricional y asistente viven en la plataforma FOOD PLAN.',
  'mi_progreso.training_external_hint': 'Abre tu panel de entrenamiento en la app dedicada.',
  'mi_progreso.tab.resumen': 'Progreso',
  'mi_progreso.tab.entrenamiento': 'Entrenamiento',
  'mi_progreso.tab.clases': 'Clases en vivo',
  'mi_progreso.tab.medidas': 'Medidas y fotos',
  'mi_progreso.tab.fotos': 'Fotos',
  'mi_progreso.tab.measures': 'Medidas corporales',
  'mi_progreso.tab.pruebas': 'Pruebas físicas',
  'mi_progreso.tab.habitos': 'Hábitos',
  'mi_progreso.tab.habitos_wellness': 'Bienestar',
  'mi_progreso.measures_training_hint': 'Registra medidas corporales y fotos de progreso con tu coach.',
  'wellness.intro': 'Cuéntanos cómo te sientes hoy: sueño, estrés, energía y apetito. Tu coach usa estos datos para ajustar tu plan.',
  'wellness.intro_short': 'Encuesta diaria de sueño, estrés y energía.',
  'wellness.open': 'Completar encuesta',
  'wellness.save': 'Guardar encuesta de hoy',
  'wellness.saved': 'Encuesta guardada',
  'wellness.saved_hint': 'Tu registro de bienestar quedó registrado para hoy.',
  'wellness.error': 'Error',
  'wellness.save_fail': 'No se pudo guardar la encuesta',
  'wellness.last_saved': 'Último registro',
  'wellness.sleep_hours': 'Sueño (horas)',
  'wellness.sleep_quality': 'Calidad de sueño',
  'wellness.stress': 'Estrés',
  'wellness.appetite': 'Apetito',
  'wellness.energy': 'Energía',
  'wellness.soreness': 'Molestias / DOMS',
  'mi_progreso.tab.asistencia': 'Asistencia',
  'mi_progreso.tab.eventos': 'Eventos',
  'mi_progreso.tab.logros': 'Logros',
  'mi_progreso.tab.pruebas': 'Pruebas físicas',
  'mi_progreso.tab.premiacion': 'Premiación',
  'mi_progreso.tests_title': 'Pruebas físicas',
  'mi_progreso.tests_hint': 'Registra abdominales, burpees, flexiones, sentadilla y plancha por ciclo.',
  'mi_progreso.open_tests': 'Ver mis pruebas',
  'mi_progreso.measures_title': 'Medidas y fotos',
  'mi_progreso.measures_hint': 'Antropometría y fotos de progreso en un solo lugar.',
  'mi_progreso.open_measures': 'Registrar medidas',
  'progress_photos.slots_hint': 'Sube 4 fotos de progreso (frente, lateral derecha, espalda y lateral izquierdo).',
  'progress_photos.slot_front': 'Frente',
  'progress_photos.slot_side': 'Lateral derecha',
  'progress_photos.slot_back': 'Espalda',
  'progress_photos.slot_detail': 'Lateral izquierdo',
  'progress_photos.phase_start': 'Inicio de ciclo',
  'progress_photos.phase_end': 'Fin de ciclo',
  'progress_photos.tap_upload': 'Toca para subir',
  'progress_photos.tap_replace': 'Toca una casilla para subir, cambiar o borrar',
  'progress_photos.delete': 'Borrar',
  'progress_photos.deleting': 'Borrando…',
  'progress_photos.deleted': 'Foto eliminada',
  'progress_photos.delete_confirm': '¿Eliminar esta foto? Podrás subir otra en su lugar.',
  'progress_photos.delete_fail': 'No se pudo eliminar la foto',
  'progress_photos.uploading': 'Subiendo…',
  'progress_photos.saved': 'Foto guardada',
  'progress_photos.error': 'Error',
  'progress_photos.too_large': 'La imagen es demasiado pesada. Usa una foto de hasta 15 MB o comprímela.',
  'progress_photos.upload_fail': 'No se pudo subir',
  'progress_photos.loading': 'Cargando fotos…',
  'progress_photos.cycle_closed_title': 'Ciclo cerrado',
  'progress_photos.cycle_closed_hint': 'El ciclo actual ya terminó. No puedes subir nuevas fotos hasta el próximo ciclo.',
  'progress_photos.premiacion_enrolled': 'Inscrito en premiación',
  'progress_photos.premiacion_not_enrolled': 'No inscrito en premiación',
  'progress_photos.progress_count': '{count} de {total} fotos',
  'progress_photos.enlarge': 'Ver foto ampliada',
  'progress_photos.pending': 'Pendiente',
  'progress_photos.upload_slot': 'Subir foto de {slot}',
  'progress_photos.replace_short': 'Cambiar',
  'progress_photos.hint': 'Sube fotos de progreso (frente, perfil o detalle) para comparar tu evolución.',
  'progress_photos.caption': 'Nota (opcional)',
  'progress_photos.caption_ph': 'Ej. Semana 4 — frente',
  'progress_photos.upload': 'Subir foto',
  'progress_photos.empty': 'Aún no tienes fotos de progreso.',
  'progress_photos.default_alt': 'Progreso',
  'progress_photos.slots_hint_cycle': 'Sube 4 fotos al inicio del ciclo y 4 al final (frente, lateral derecha, espalda y lateral izquierdo).',
  'mi_progreso.live_classes_title': 'Clases en vivo',
  'mi_progreso.live_classes_hint': 'Consulta el horario, inscríbete y entra al Zoom cuando empiece la sesión.',
  'mi_progreso.open_live_classes': 'Ver clases e inscribirme',
  'mi_progreso.food_legacy_hint': 'Tu registro nutricional diario está en FOOD_PLAN desde Inicio → FOOD_PLAN.',
  'mi_progreso.photos_title': 'Fotos de progreso',
  'mi_progreso.food_habits': 'Registro de comidas, medidas y chat nutricional viven en FOOD_PLAN.',
  'mi_progreso.open_food': 'Ir a Food Plan',
  'mi_progreso.open_training': 'Abrir entrenamiento',
  'mi_progreso.training_dashboard_title': 'Mi dashboard de entrenamiento',
  'mi_progreso.training_dashboard_hint': 'Rutina del día, registro de series y galería de videos de tu coach.',
  'mi_progreso.open_training_dashboard': 'Abrir entrenamiento',
  'mi_progreso.no_habits': 'Sin módulos de hábitos activos.',
  'mi_progreso.logros_hint': 'Completa eventos en la pestaña Eventos para desbloquear podios y reconocimientos.',

  'd28d.progress.title': 'Resumen Fit Live · Programa',
  'd28d.progress.traffic_light': 'Semáforo',
  'd28d.progress.traffic.green': 'Verde',
  'd28d.progress.traffic.yellow': 'Amarillo',
  'd28d.progress.traffic.red': 'Rojo',
  'd28d.tracking.traffic_title': 'Avisos de semáforo (adherencia)',
  'd28d.tracking.traffic_optin': 'Enviar avisos in_app/email de semáforo a usuarios de Fit Live · Programa (opt-in)',
  'd28d.tracking.traffic_hint': 'Desactivado por defecto. Requiere job D28D_TRAFFIC_LIGHT_JOB en el servidor.',
  'd28d.tracking.traffic_saved': 'Guardado',
  'd28d.tracking.traffic_save_error': 'No se pudo guardar',
  'd28d.progress.attendance': 'Asistencia',
  'd28d.progress.events': 'Eventos',
  'd28d.progress.enrolled': 'Inscritos',
  'd28d.progress.completed': 'Completados',
  'd28d.progress.won': 'Ganados',
  'd28d.progress.adherence': 'Tu avance semanal',
  'd28d.progress.active_days': 'Días activos',
  'd28d.progress.plan_days': 'Días del plan',
  'd28d.progress.results_title': 'Resultados del ciclo',
  'd28d.progress.attendance_pct': '% asistencia',
  'd28d.progress.cycle_pct': 'Avance del ciclo',
  'd28d.progress.premiacion_yes': 'Inscrito',
  'd28d.progress.premiacion_open': 'Disponible',
  'd28d.progress.last_weight': 'Último peso',
  'd28d.progress.compare_classes': 'Inscritos vs asistidos',
  'd28d.progress.weight_trend': 'Tendencia de peso',
  'd28d.progress.validity': 'Vigencia',
  'd28d.progress.validity_active': 'Activa',
  'd28d.progress.validity_pending': 'Pendiente de activación',
  'd28d.progress.loading': 'Cargando progreso…',
  'd28d.progress.load_error': 'No se pudo cargar tu progreso del programa.',

  'd28d.challenges.title': 'Eventos',
  'd28d.challenges.enrolled_ok': 'Inscripción confirmada',
  'd28d.challenges.withdrawn': 'Te retiraste del reto',
  'd28d.challenges.evidence_sent': 'Evidencia enviada',
  'd28d.challenges.file_uploaded': 'Archivo subido',
  'd28d.challenges.prize': 'Premio',
  'd28d.challenges.status': 'Estado',
  'd28d.challenges.join': 'Participar',
  'd28d.challenges.withdraw': 'Retirarme',
  'd28d.challenges.upload_evidence': 'Subir evidencia',
  'd28d.challenges.comment_ph': 'Comentario o texto',
  'd28d.challenges.send_text': 'Enviar texto',
  'd28d.challenges.file': 'Archivo',
  'd28d.challenges.winners': 'Ganadores',
  'd28d.challenges.ranking': 'Ranking',

  'training.progress.loading': 'Cargando cumplimiento training…',
  'training.progress.title': 'Mi cumplimiento Training',
  'training.progress.traffic': 'Semáforo',
  'training.progress.adherence_plan_days': 'Cumplimiento semanal ({days} días)',
  'training.progress.sessions': 'Sesiones',

  'services.greeting': 'Hola, {name}',
  'services.greeting_short': 'Hola',
  'services.no_services': 'Aún no tienes servicios activos en {brand}. Contacta a tu coach o al equipo de tu gimnasio para activarlos.',
  'services.title_multi': 'TUS SERVICIOS',
  'services.title_single': 'TU ESPACIO',
  'services.welcome_multi': 'Bienvenido a {brand}. Entra al módulo que quieras revisar hoy.',
  'services.welcome_single': 'Bienvenido a {brand}.',
  'services.open_aria': 'Abrir {title}',

  'masters.title': 'MAESTROS DEL SISTEMA',
  'masters.subtitle_v3': 'Administración separada por dominio: plataforma, Food, Training, Fútbol y Viento Recio.',
  'masters.open_aria': 'Abrir maestro {title}',

  'panel.back_services': '← Servicios',
  'panel.back_home': '← Volver al inicio',
  'panel.open': 'Abrir',
  'panel.active_programs': 'Programas activos',
  'panel.operation': 'Operación',
  'panel.d28d_masters': 'Maestros gimnasio virtual',
  'panel.d28d_masters_desc': 'Catálogo y configuración del gimnasio virtual semilla: rutinas plantilla, planes comerciales y apariencia. Lo operativo del día a día está arriba en Operación.',
  'panel.white_label_gyms': 'Gimnasios marca blanca',
  'panel.white_label_desc_admin': 'Los gimnasios marca blanca consumen el contenido de Fit Live · Programa y agendan sobre las plantillas de clases en vivo.',
  'panel.white_label_desc_user': 'Tu gimnasio consume el contenido de Fit Live · Programa y agenda sobre las plantillas de clases en vivo.',

  'panel.food-plan.cards.adminusers.title': 'Usuarios',
  'panel.food-plan.cards.adminusers.desc': 'Personas con plan nutricional asignado.',
  'panel.food-plan.cards.admin.title': 'Configurar planes',
  'panel.food-plan.cards.admin.desc': 'Define o ajusta el plan de cada usuario.',
  'panel.food-plan.cards.progress.title': 'Seguimiento',
  'panel.food-plan.cards.progress.desc': 'Cumplimiento y evolución nutricional de los usuarios.',
  'panel.food-plan.cards.calculator.title': 'Calculadora nutricional',
  'panel.food-plan.cards.calculator.desc': 'Calcula una referencia inicial para el usuario.',
  'panel.food-plan.cards.foodsmanager.title': 'Alimentos (catálogo)',
  'panel.food-plan.cards.foodsmanager.desc': 'Lista de alimentos, macros y porciones de referencia.',
  'panel.food-plan.cards.foodlog.title': 'Registro de comidas',
  'panel.food-plan.cards.foodlog.desc': 'Diario nutricional de los usuarios.',
  'panel.food-plan.cards.equivalentes.title': 'Equivalentes por grupo',
  'panel.food-plan.cards.equivalentes.desc': 'Sustituciones manteniendo macros.',
  'panel.food-plan.cards.recipes.title': 'Recetas',
  'panel.food-plan.cards.recipes.desc': 'Biblioteca de recetas saludables.',
  'panel.food-plan.cards.modulevigencias.title': 'Vigencias',
  'panel.food-plan.cards.modulevigencias.desc': 'Confirmación de pagos y extensiones de licencia.',

  'panel.training.cards.training.title': 'Mi entrenamiento',
  'panel.training.cards.training.desc': 'Vista de la rutina del día con sustituciones asistidas.',
  'panel.training.cards.coachbrand.title': 'Mi marca blanca',
  'panel.training.cards.coachbrand.desc': 'Logo, colores y mensaje de bienvenida de tu coach.',
  'panel.training.cards.coachroutines.title': 'Rutinas',
  'panel.training.cards.coachroutines.desc': 'Bloques, ejercicios, videos y versiones (catálogo privado).',
  'panel.training.cards.coachai.title': 'Asistente IA',
  'panel.training.cards.coachai.desc': 'Genera rutinas y planes desde tu galería (100% gratuito, motor local).',
  'panel.training.cards.admintraining.title': 'Planificación',
  'panel.training.cards.admintraining.desc': 'Planes por usuario, días y diario de entrenamiento.',
  'panel.training.cards.admingallery.title': 'Galería de videos',
  'panel.training.cards.admingallery.desc': 'Videos por ejercicio (referencia visual).',
  'panel.training.cards.adminusers.title': 'Clientes',
  'panel.training.cards.adminusers.desc': 'Personas asignadas a tu operación de coach.',
  'panel.training.cards.coachai.title': 'IA Rutinas',
  'panel.training.cards.coachai.desc': 'Genera rutinas y planes desde tu galería.',
  'panel.training.cards.admintraining.title': 'Planes',
  'panel.training.cards.admintraining.desc': 'Plantillas, asignaciones y diario de entrenamiento.',
  'panel.training.cards.admingallery.title': 'Galería',
  'panel.training.cards.admingallery.desc': 'Videos por ejercicio (referencia visual).',
  'panel.training.cards.progress.title': 'Seguimiento',
  'panel.training.cards.progress.desc': 'Adherencia, alertas y avance de tus usuarios.',
  'panel.training.cards.training-stats.title': 'Estadísticas',
  'panel.training.cards.training-stats.desc': 'Cargas, progresión y métricas básicas del equipo.',
  'training.back_d28d': '← D28D',
  'training.back_panel': '← Entrenadores',

  'panel.gym.cards.admingyms.title': 'Mi marca',
  'panel.gym.cards.admingyms.desc': 'Logo, colores, mensaje y WhatsApp de soporte.',
  'panel.gym.cards.adminusers.title': 'Usuarios',
  'panel.gym.cards.adminusers.desc': 'Altas, roles y licencias por módulo.',
  'panel.gym.cards.adminplans.title': 'Vigencias',
  'panel.gym.cards.adminplans.desc': 'Cuentas y fechas de vencimiento.',
  'panel.gym.cards.liveclasses.title': 'Clases en vivo',
  'panel.gym.cards.liveclasses.desc': 'Ver clases de Fit Live · Programa habilitadas para tu gym.',

  'panel.d28d.cards.liveclasses.title': 'Clases en vivo y reuniones',
  'panel.d28d.cards.liveclasses.desc': 'Programa plantillas y revisa el calendario con links de Zoom.',
  'panel.d28d.cards.programs.title': 'Fit Live · Programas',
  'panel.d28d.cards.programs.desc': 'Ciclos y configuración de los 3 programas principales.',
  'panel.d28d.cards.d28d-routines.title': 'Fit Live · Rutinas',
  'panel.d28d.cards.d28d-routines.desc': 'Plantillas de rutinas para clases en vivo y entrenamiento.',
  'panel.d28d.cards.d28d-challenges-admin.title': 'Premiaciones por ciclo',
  'panel.d28d.cards.d28d-challenges-admin.desc': 'Inscripciones, evidencias, fotos y podio de ganadores por ciclo activo.',
  'panel.d28d.cards.admingallery.title': 'Galería de videos',
  'panel.d28d.cards.admingallery.desc': 'Videos por ejercicio para rutinas y clases.',
  'panel.d28d.cards.d28d-gallery.title': 'GRABACIONES DE CLASE',
  'panel.d28d.cards.d28d-gallery.desc': 'Grabaciones y enlaces de clases en vivo ya realizadas, con contador de visualizaciones.',
  'd28d.gallery.title': 'GRABACIONES DE CLASE',
  'd28d.gallery.subtitle': 'Grabaciones y enlaces de clases en vivo ya realizadas. Independiente de la biblioteca de ejercicios de entrenadores.',
  'd28d.gallery.scope': 'Alcance',
  'd28d.gallery.views': 'Vistas',
  'd28d.gallery.load_error': 'Error cargando las grabaciones de clase',
  'd28d.gallery.publish': '+ Publicar grabación',
  'd28d.gallery.search': 'Buscar por título, coach o programa…',
  'd28d.gallery.filter_cycle': 'Filtrar visualizaciones por ciclo',
  'd28d.gallery.filter_month': 'Mes de visualizaciones',
  'd28d.gallery.filter_year': 'Año de visualizaciones',
  'd28d.gallery.all_cycles': 'Todos los ciclos',
  'd28d.gallery.all_months': 'Todos los meses',
  'd28d.gallery.all_years': 'Todos los años',
  'd28d.gallery.views_filter_hint': 'Los filtros aplican al contador de visualizaciones.',
  'gym.gallery.title': 'GRABACIONES DE CLASE de tu sede',
  'gym.gallery.subtitle': 'Grabaciones y enlaces de las clases en vivo de tu gimnasio virtual. Solo visible para usuarios de tu sede.',
  'gym.gallery.need_program': 'Crea un programa en Maestros → Programas antes de publicar grabaciones.',
  'gym.home.gallery_classes_desc': 'Grabaciones de clase on-demand de tu sede, con visualizaciones por ciclo/mes/año.',
  'gym.home.branding_cta': 'Configurar marca blanca →',
  'gym.home.masters_desc': 'Parametriza marca, planes, usuarios, entrenadores y clases de tu sede.',
  'gym.home.masters_cta': 'Abrir maestros →',
  'gym.home.subtitle': 'Operación de tu sede: usuarios, asistencia, reportes y licencias.',
  'gym.home.users_desc': 'Personas de tu sede, accesos y operación diaria.',
  'gym.home.attendance': 'Asistencia',
  'gym.home.attendance_desc': 'Registro de asistencia de tus usuarios a las clases.',
  'gym.attendance.subtitle': 'Consulta quién asistió a cada clase de tu sede. Para programar nuevas sesiones, usa Maestros → Clases en vivo.',
  'gym.home.branding_desc': 'Logo, colores y marca de tu gimnasio.',
  'gym.home.licenses_desc': 'Vigencias, pagos pendientes y renovaciones.',
  'gym.masters.brand': 'Mi marca y contacto',
  'gym.masters.brand_desc': 'Logo, colores, correo, teléfono y WhatsApp de tu sede.',
  'gym.masters.plans': 'Planes comerciales',
  'gym.masters.plans_desc': 'Crea planes de suscripción de tu gimnasio y asígnalos a programas y ciclos.',
  'gym.masters.plans_help': 'Aquí defines los planes comerciales (precio, nombre, módulos). Crea primero ciclos y programas en Maestros, luego asígnalos al crear cada plan.',
  'gym.masters.cycles': 'Ciclos',
  'gym.masters.cycles_desc': 'Calendario de ciclos propios de tu sede (inicio y fin personalizables).',
  'gym.masters.programs': 'Programas',
  'gym.masters.programs_desc': 'Programas propios de tu sede para vincular a los planes.',
  'gym.programs.configure': 'Configurar',
  'gym.masters.routines': 'Rutinas',
  'gym.masters.routines_desc': 'Plantillas de rutinas propias de tu sede para clases en vivo.',
  'gym.masters.challenges': 'Premiaciones',
  'gym.masters.challenges_desc': 'Premiación por ciclo de 28 días para usuarios de tu sede.',
  'gym.masters.open_hub': 'Abrir Maestros de mi sede →',
  'gym.masters.cycles_desc_linked': 'Define el periodo de cada ciclo con fecha de inicio y fin, vincula los programas de tu sede y asígnalos en Planes.',
  'gym.cycles.end': 'Fecha de fin',
  'gym.cycles.duration': 'Duración',
  'gym.cycles.days': 'días',
  'gym.cycles.end_required': 'Indica la fecha de fin del ciclo.',
  'gym.cycles.end_before_start': 'La fecha de fin debe ser igual o posterior al inicio.',
  'gym.cycles.programs_in_cycle': 'Programas en este ciclo',
  'gym.cycles.select_all_programs': 'Seleccionar todos',
  'gym.cycles.clear_programs': 'Quitar todos',
  'gym.cycles.need_programs': 'Crea programas en Maestros → Programas para vincularlos a cada ciclo.',
  'gym.cycles.no_programs_yet': 'Sin programas en tu sede.',
  'panel.d28d.cards.gym-masters-cycles.title': 'Ciclos',
  'panel.d28d.cards.gym-masters-cycles.desc': 'Calendario de ciclos de 28 días propios de tu sede.',
  'panel.d28d.cards.gym-masters-programs.title': 'Programas',
  'panel.d28d.cards.gym-masters-programs.desc': 'Programas propios con Zoom, ciclos y planes comerciales.',
  'panel.d28d.cards.gym-masters-routines.title': 'Rutinas',
  'panel.d28d.cards.gym-masters-routines.desc': 'Plantillas de rutinas para clases en vivo de tu sede.',
  'panel.d28d.cards.gym-masters-challenges.title': 'Premiaciones',
  'panel.d28d.cards.gym-masters-challenges.desc': 'Premiación por ciclo para usuarios de tu gimnasio.',
  'panel.d28d.cards.masters-hub.title': 'Maestros',
  'panel.d28d.cards.masters-hub.desc': 'Panel unificado de configuración de tu gimnasio virtual.',
  'panel.d28d.cards.modulevigencias.title': 'Vigencias',
  'panel.d28d.cards.modulevigencias.desc': 'Pagos y licencias de usuarios de tu sede.',
  'gym.masters.users_title': 'Usuarios de {gym}',
  'gym.masters.users_subtitle': 'Solo personas registradas en tu sede virtual.',
  'gym.plans.need_programs': 'Primero crea un programa en Maestros → Programas para poder asociarlo al plan.',
  'gym.programs.init_masters': 'Inicializar estructura (ciclo + programa)',
  'gym.programs.masters_ready': 'Estructura creada: ciclo + programa listos. Configura la cuenta Zoom en Configurar → Zoom.',
  'gym.programs.already_ready': 'La estructura maestra ya está lista.',
  'gym.programs.provision_error': 'No se pudo inicializar la estructura maestra',
  'gym.programs.new': 'Nuevo programa',
  'gym.programs.name': 'Nombre del programa',
  'gym.programs.color': 'Color',
  'gym.programs.active_cycle': 'Ciclo activo',
  'gym.programs.active': 'Activo',
  'gym.programs.none': 'Aún no hay programas. Crea el primero para tu gimnasio.',
  'gym.programs.need_cycles': 'Primero crea al menos un ciclo en Maestros → Ciclos para vincularlo al programa.',
  'gym.programs.created': 'Programa creado',
  'gym.programs.updated': 'Programa actualizado',
  'gym.programs.deleted': 'Programa eliminado',
  'gym.programs.delete_confirm': '¿Borrar este programa?',
  'gym.programs.delete_error': 'No se pudo borrar el programa',
  'gym.programs.save_error': 'Error guardando programa',
  'gym.programs.error_loading': 'Error cargando programas',
  'gym.programs.name_required': 'El nombre del programa es obligatorio',
  'gym.programs.zoom': 'Zoom',
  'gym.programs.zoom_pending': 'Sin configurar',
  'gym.masters.plans_page_lead': 'planes comerciales de tu sede',
  'gym.masters.plans_embedded_hint': 'Crea un plan con «Crear plan» y en el formulario marca los ciclos incluidos.',
  'gym.masters.users_desc': 'Personas de tu sede, accesos y operación diaria.',
  'gym.masters.trainers': 'Entrenadores',
  'gym.masters.trainers_desc': 'Entrenadores propios de tu sede (rol entrenador de gimnasio): clases en vivo, rutinas y Zoom.',
  'gym.masters.live_desc': 'Programar clases en vivo y registro de asistencia.',
  'gym.masters.gallery_desc': 'Grabaciones y enlaces de clases ya realizadas en tu sede.',
  'gym.masters.vigencias_desc': 'Vigencias, pagos pendientes y renovaciones.',
  'gym.masters.subtitle': 'Parametriza tu gimnasio virtual: marca, planes, usuarios, entrenadores y clases.',
  'gym.masters.plans_active': 'planes activos',
  'gym.masters.plans_pending': 'sin planes configurados aún',
  'gym.masters.your_gym': 'Tu gimnasio virtual',
  'nav.users': 'Usuarios',
  'tenants.back_list': '← Gimnasios virtuales',
  'tenants.panel_title': 'Panel',
  'superadmin.home.subtitle': 'Operación por dominio: plataforma, Fit Live · Programa, FOOD y Entrenadores — sin mezclar dashboards.',
  'finance.card': 'Resumen financiero',
  'finance.title': 'Resumen financiero',
  'finance.subtitle': 'Pagos confirmados, licencias, bajas y egresos — solo super_admin.',
  'finance.home_preview': 'Mes actual (COP). Abre el tablero para gráficos, drill y egresos.',
  'finance.open_board': 'Abrir tablero',
  'finance.back': 'Volver al inicio',
  'finance.refresh': 'Actualizar',
  'finance.period.month': 'Mes actual',
  'finance.period.last12': 'Últimos 12 meses',
  'finance.kpi.revenue': 'Ingresos',
  'finance.kpi.expenses': 'Egresos',
  'finance.kpi.net': 'Neto',
  'finance.kpi.active': 'Activos',
  'finance.kpi.inactive': 'Inactivos',
  'finance.kpi.withdrawals': 'Bajas',
  'finance.kpi.revenue_hint': 'Pagos confirmados del periodo',
  'finance.kpi.expenses_hint': 'Gastos cargados por Excel',
  'finance.kpi.net_hint': 'Ingresos menos egresos',
  'finance.kpi.active_hint': 'Licencias vigentes',
  'finance.kpi.inactive_hint': 'Licencias vencidas o off',
  'finance.kpi.withdrawals_hint': 'Vencidas sin renovar + cancelados',
  'finance.kpi.active_end_users': 'Usuarios finales',
  'finance.kpi.active_trainers': 'Entrenadores',
  'finance.kpi.active_in_period': 'Activos en el periodo',
  'finance.kpi.renewed': 'Renovados',
  'finance.kpi.active_end_users_hint': 'Plan Food vigente ahora (no vencido)',
  'finance.kpi.active_trainers_hint': 'Vigentes ahora · En el periodo: {n}',
  'finance.kpi.active_in_period_hint': 'Finales con vigencia real en el mes · Entrenadores en el periodo: {n}',
  'finance.kpi.renewed_hint': 'Nueva suscripción o extensión Nest en el periodo',
  'finance.kpi.food_licenses': 'Licencias',
  'finance.kpi.food_licenses_hint': 'Misma pestaña Licencias de Vigencias Food',
  'finance.kpi.food_activo': 'Activos',
  'finance.kpi.food_activo_hint': 'Mismo filtro Activo de Vigencias Food',
  'finance.kpi.food_revenue_hint': 'Suma de planes en estado Activo (Vigencias Food)',
  'finance.kpi.food_net_hint': 'Ingresos de activos − egresos',
  'finance.kpi.food_revisado': 'Revisado',
  'finance.kpi.food_pending': 'Pendientes',
  'finance.kpi.food_pending_hint': 'Pago pendiente en Vigencias Food',
  'finance.kpi.food_inactive': 'Inactivo',
  'finance.kpi.food_expiring': 'Por vencer',
  'finance.kpi.food_expiring_hint': '0 a 30 días, igual que Vigencias Food',
  'finance.chart.food_roster': 'Licencias Food (espejo Vigencias)',
  'finance.renewed.title': 'Renovaciones del periodo',
  'finance.renewed.subtitle': 'Usuarios finales de Vigencias Food que renovaron en este rango.',
  'finance.renewed.empty': 'Nadie renovó en este periodo.',
  'finance.renewed.role_user': 'Usuario final',
  'finance.renewed.role_trainer': 'Entrenador',
  'finance.renewed.kind_extension': 'Extensión',
  'finance.renewed.kind_new_row': 'Nueva suscripción',
  'users.activate_finance_zero': 'Sin ingreso ($0)',
  'users.activate_finance_zero_hint': 'Solo super_admin. Staff, cortesía o prueba: no suma en Finanzas. En el detalle aparece etiquetado.',
  'finance.subtitle_compact': 'Haz clic en las barras para profundizar (módulo → programa → plan → usuario).',
  'finance.subtitle_scoped': 'Solo datos de este módulo. Haz clic en barras para profundizar.',
  'finance.title.d28d': 'Finanzas Fit Live · Programa',
  'finance.title.food': 'Finanzas FOOD',
  'finance.title.training': 'Finanzas Training',
  'panel.d28d.cards.finance-d28d.title': 'Finanzas Fit Live · Programa',
  'panel.d28d.cards.finance-d28d.desc': 'Ingresos, egresos y drill solo de Fit Live · Programa.',
  'panel.food-plan.cards.finance-food.title': 'Finanzas FOOD',
  'panel.food-plan.cards.finance-food.desc': 'Ingresos Food y headcount espejo de Vigencias Food (sin Fit Live · Programa ni Training).',
  'panel.training.cards.finance-training.title': 'Finanzas Training',
  'panel.training.cards.finance-training.desc': 'Ingresos, egresos y drill solo de Entrenadores.',
  'nav.finance_coach': 'Finanzas afiliados',
  'finance.title.coach': 'Finanzas de mis afiliados',
  'finance.subtitle_coach': 'Mismo tablero Training, solo ingresos y KPIs de tus afiliados.',
  'finance.chart.programs': 'Ingresos por programa',
  'finance.chart.licenses': 'Licencias por módulo',
  'finance.chart.trend': 'Tendencia 12 meses',
  'finance.chart.revenue': 'Ingresos 12 meses',
  'finance.chart.mix': 'Mix por módulo',
  'finance.drill.title': 'Detalle',
  'finance.expenses.title': 'Egresos (Excel)',
  'finance.expenses.help': 'Descarga la plantilla, completa montos COP/USD y súbela. Se suman al neto del periodo.',
  'superadmin.section.platform': 'Plataforma',
  'superadmin.section.platform_desc': 'Usuarios globales, organizaciones, finanzas, maestros y configuración del ecosistema.',
  'superadmin.section.d28d': 'Fit Live · Programa',
  'superadmin.section.d28d_desc': 'Programas, clases en vivo, galería de grabaciones y operación de sedes.',
  'superadmin.section.food': 'FOOD PLAN',
  'superadmin.section.food_desc': 'Nutrición, planes y usuarios del módulo alimentación.',
  'superadmin.section.training': 'Entrenadores',
  'superadmin.section.training_desc': 'Coaches, rutinas, biblioteca de ejercicios y seguimiento.',
  'nav.food_plan': 'FOOD PLAN',
  'panel.d28d.cards.admingyms.title': 'Gimnasios',
  'panel.d28d.cards.admingyms.desc': 'Branding, equipo y configuración de marca blanca.',
  'panel.d28d.cards.adminusers.title': 'Usuarios de gimnasios',
  'panel.d28d.cards.adminusers.desc': 'Listado y gestión de personas afiliadas.',
  'panel.d28d.cards.d28d-trainers.title': 'Fit Live · Entrenadores',
  'panel.d28d.cards.d28d-trainers.desc': 'Hosts de clases: rutinas, asignación y Zoom. Sin código de vinculación.',
  'panel.d28d.cards.admincompanies.title': 'Asignaciones',
  'panel.d28d.cards.admincompanies.desc': 'Crear usuarios, asignar gimnasio o coach, planes e invitaciones.',
  'panel.d28d.cards.adminliveclasses.title': 'Clases en vivo (sede)',
  'panel.d28d.cards.adminliveclasses.desc': 'Agenda y asistencia de clases para tu gimnasio.',
  'panel.d28d.cards.gym-masters-plans.title': 'Planes',
  'panel.d28d.cards.gym-masters-plans.desc': 'Planes comerciales de tu sede: precio, programas y ciclos de 28 días.',

  'panel.training.cards.admintrainers.title': 'Entrenadores',
  'panel.training.cards.admintrainers.desc': 'Alta de coaches, capacidad y usuarios vinculados.',

  'appearance.title': 'Maestro de apariencia',
  'appearance.subtitle': 'Imágenes por URL o archivo subido. Tema claro/oscuro, marca, login, servicios y paneles internos.',
  'appearance.loading': 'Cargando maestro de apariencia…',
  'appearance.load_error': 'No se pudo cargar la configuración',
  'appearance.save_ok': 'Configuración guardada.',
  'appearance.save_error': 'Error al guardar',
  'appearance.reset_ok': 'Valores por defecto restaurados.',
  'appearance.reset_error': 'No se pudo restaurar',
  'appearance.reset_confirm': '¿Restaurar valores por defecto de apariencia?',
  'appearance.save': 'Guardar cambios',
  'appearance.saving': 'Guardando…',
  'appearance.reset': 'Restaurar por defecto',
  'appearance.tab.theme': 'Tema',
  'appearance.tab.brand': 'Marca',
  'appearance.tab.auth': 'Login',
  'appearance.tab.services': 'Servicios',
  'appearance.tab.masters': 'Maestros hub',
  'appearance.tab.programs': 'Programas',
  'appearance.tab.panels': 'Paneles admin',
  'appearance.theme_title': 'Tema visual',
  'appearance.theme_hint': 'Oscuro: fondo negro puro. Claro: fondo gris claro con tarjetas oscuras; textos blancos y amarillos.',
  'appearance.theme_dark': 'Oscuro',
  'appearance.theme_light': 'Claro',
  'appearance.accent': 'Color acento',
  'appearance.brand_title': 'Marca pública',
  'appearance.brand_name': 'Nombre',
  'appearance.brand_tagline': 'Eslogan',
  'appearance.logo': 'Logo navbar (URL o archivo)',
  'appearance.auth_title': 'Login / registro',
  'appearance.auth_line_white': 'Línea blanca',
  'appearance.auth_line_y1': 'Línea amarilla 1',
  'appearance.auth_line_y2': 'Línea amarilla 2',
  'appearance.auth_subtitle': 'Subtítulo',
  'appearance.auth_cta': 'Botón decorativo',
  'appearance.panel_select': 'Panel a editar',
  'appearance.panel_hero': 'Cabecera del panel',
  'appearance.panel_hero_img': 'Imagen cabecera (opcional)',
  'appearance.panel_hero_title': 'Título cabecera',
  'appearance.panel_hero_sub': 'Subtítulo cabecera',
  'appearance.panel_no_cards': 'Guarda la config por defecto o restaura para ver las tarjetas de este panel.',
  'appearance.card_label': 'Tarjeta: {id}',
  'appearance.img_card': 'Imagen de tarjeta',
  'appearance.img': 'Imagen',
  'appearance.alt': 'Texto alternativo',
  'appearance.card_title': 'Título tarjeta',
  'appearance.desc_user': 'Descripción (usuario)',
  'appearance.desc_admin': 'Descripción (admin)',
  'appearance.desc': 'Descripción',
  'appearance.name': 'Nombre',

  'image.upload': 'Subir archivo',
  'image.uploading': 'Subiendo…',
  'image.remove': 'Quitar',
  'image.no_image': 'Sin imagen',
  'image.url_label': 'URL (externa o subida)',
  'image.hint': 'JPG, PNG, WebP o GIF · máximo 5 MB. Puedes usar URL o archivo.',
  'image.upload_error': 'Error al subir la imagen',
  'image.upload_no_url': 'No se recibió URL del servidor',

  'payments.title': 'Enlaces de pago por módulo',
  'payments.subtitle': 'Solo super_admin. URLs externas (Mercado Pago, Stripe, etc.).',
  'payments.subtitle_programs': 'Por módulo (base) y, si hace falta, por programa activo. Si un programa no tiene configuración propia, usa la del módulo.',
  'payments.loading': 'Cargando enlaces…',
  'payments.load_error': 'No se pudieron cargar los enlaces de pago',
  'payments.save_error': 'Error al guardar',
  'payments.delete_error': 'No se pudo eliminar la configuración del programa',
  'payments.delete_override': 'Quitar (usar módulo)',
  'payments.active': 'Activo (visible en registro si hay URL)',
  'payments.save': 'Guardar',
  'payments.wompi_url': 'Enlace Wompi (pago en línea)',
  'payments.online_label': 'Etiqueta pago en línea',
  'payments.in_person_enabled': 'Habilitar pago en sede',
  'payments.in_person_label': 'Etiqueta pago en sede',
  'payments.module_default': 'Configuración base del módulo',
  'payments.module_default_hint': 'Se usa cuando el programa no tiene configuración propia.',
  'payments.program_overrides': 'Configuración por programa activo',
  'payments.add_program': 'Añadir configuración de programa',
  'payments.select_program': 'Seleccionar programa…',
  'payments.create_override': 'Crear configuración',
  'payments.no_more_programs': 'No hay más programas activos sin configuración propia.',
  'vigencias.title': 'Pagos, vigencias y notificaciones',
  'vigencias.subtitle': 'Confirma pagos en sede, revisa vencimientos y extiende licencias por módulo.',
  'vigencias.loading': 'Cargando vigencias…',
  'vigencias.load_error': 'No se pudo cargar vigencias y pagos',
  'vigencias.pending': 'Pagos pendientes',
  'vigencias.no_pending': 'Sin pagos pendientes.',
  'vigencias.expiring': 'Cuentas por vencer',
  'vigencias.no_expiring': 'Nada por vencer en los próximos 30 días.',
  'vigencias.licenses': 'Licencias por módulo',
  'vigencias.confirm': 'Confirmar pago',
  'vigencias.renew': 'Renovar',
  'vigencias.renew_modal_title': 'Renovar',
  'vigencias.renew_with_days': 'Renovar {n} días',
  'vigencias.alert_renew_suffix': 'Revisa vigencias y renueva.',
  'vigencias.renew_verb': 'renueva',
  'vigencias.extend': 'Extender',
  'vigencias.days_prompt': 'Días a extender',
  'vigencias.back_masters': 'Volver a Maestros',
  'vigencias.filter_all': 'Todos',
  'vigencias.filter_module': 'Módulo',
  'vigencias.filter_client': 'Cliente',
  'vigencias.filters_aria': 'Filtros de vigencias',
  'vigencias.filter_new_client': 'Nuevo',
  'vigencias.filter_old_client': 'Antiguo',
  'vigencias.client_new': 'Nuevo',
  'vigencias.client_old': 'Antiguo',
  'vigencias.col_client_type': 'Cliente',
  'vigencias.couple_guest': 'Pareja (invitado)',
  'vigencias.couple_owner': 'Pareja (titular)',
  'vigencias.col_last_wa': 'Último WA',
  'vigencias.bulk_queue_hint': 'Se abrió 1 conversación. Quedan {n}: pulsa «Abrir siguiente» para cada una.',
  'vigencias.bulk_queue_status': 'Cola WhatsApp {i}/{n}: {name}',
  'vigencias.bulk_queue_next': 'Abrir siguiente',
  'vigencias.bulk_queue_cancel': 'Cancelar cola',
  'vigencias.bulk_queue_done': 'Cola de WhatsApp completada.',
  'vigencias.bulk_skip_title': 'Sin teléfono',
  'vigencias.bulk_skip_phone': '{n} seleccionado(s) sin teléfono se omitieron.',
  'vigencias.filter_pending_payment': 'Pendiente por pago',
  'vigencias.whatsapp_activate': 'Contactar por WhatsApp',
  'vigencias.no_phone': 'Sin teléfono registrado',
  'vigencias.confirm_success_title': 'Pago confirmado',
  'vigencias.confirm_success': 'Vigencia activada 30 días',
  'vigencias.confirm_success_deferred': 'Pago registrado. El acceso se habilitará al iniciar el ciclo.',
  'vigencias.confirm_error': 'No se pudo confirmar',
  'vigencias.reject_success_title': 'Pago rechazado',
  'vigencias.reject_success': 'El usuario fue notificado',
  'vigencias.reject_error': 'No se pudo rechazar',
  'vigencias.col_user': 'Usuario',
  'vigencias.col_module': 'Módulo',
  'vigencias.col_plan': 'Plan',
  'vigencias.col_phone': 'Teléfono',
  'vigencias.col_days': 'Días',
  'vigencias.col_status': 'Estado',
  'vigencias.col_expiry': 'Vence',
  'vigencias.col_actions': 'Acción',
  'vigencias.status_active': 'activo',
  'vigencias.starts_on': 'Inicia',
  'vigencias.deferred_cycle': 'Ciclo desde',
  'vigencias.no_license_match': 'Ninguna licencia coincide con el filtro.',
  'vigencias.search_pending': 'Buscar por nombre o email…',
  'vigencias.no_pending_match': 'Ningún pago pendiente coincide con la búsqueda.',
  'vigencias.reject': 'Rechazar',
  'vigencias.admin_alerts': 'Alertas de pago pendiente',
  'vigencias.subtitle_gym_pending_only': 'Pagos pendientes de usuarios de tu gimnasio y sedes (habilitación manual).',
  'vigencias.subtitle_gym': 'Licencias y pagos de usuarios de tu gimnasio virtual.',
  'vigencias.wa_new_client': 'Hola {name}, bienvenido/a a Fit Live. Tu cuenta está registrada y pendiente de activación. ¿Podemos ayudarte a completar el proceso?',
  'vigencias.wa_pending_payment': 'Hola {name}, tu servicio Fit Live · Programa está pendiente de pago o habilitación. Escríbenos si necesitas ayuda para activarlo.',
  'vigencias.export_excel': 'Exportar Excel (CSV)',
  'vigencias.export_empty': 'No hay filas para exportar.',
  'vigencias.export_ok_title': 'Exportado',
  'vigencias.export_ok': 'Se descargó el archivo CSV (abre con Excel).',
  'vigencias.bulk_hint': 'Escribe un mensaje, elige destinatarios en la tabla y envía. Usa {nombre} para el nombre. Se abre WhatsApp por cada teléfono único.',
  'vigencias.bulk_placeholder': 'Mensaje para los seleccionados…',
  'vigencias.bulk_send': 'Enviar WhatsApp a seleccionados ({n})',
  'vigencias.bulk_sending': 'Abriendo…',
  'vigencias.bulk_selected': '{n} filas seleccionadas',
  'vigencias.bulk_no_phone': 'Ningún seleccionado tiene teléfono.',
  'vigencias.bulk_sent_title': 'WhatsApp',
  'vigencias.bulk_sent': 'Se abrieron {n} conversaciones.',
  'vigencias.select_all': 'Seleccionar todos',
  'vigencias.select_row': 'Seleccionar',
  'myaccount.wompi_hint': 'Al confirmar se abrirá el checkout Wompi en una nueva pestaña.',
  'myaccount.sede_hint': 'Tu entrenador o administrador recibirá la notificación y activará tu vigencia.',

  'legal.privacy_title': 'Política de Privacidad',
  'legal.terms_title': 'Términos y Condiciones',
  'legal.accept_continue': 'Aceptar y Continuar',

  'register.title': 'Crear cuenta',
  'register.accept_privacy': 'Acepto la',
  'register.privacy_link': 'Política de Privacidad',
  'register.accept_terms': 'Acepto los',
  'register.terms_link': 'Términos y Condiciones',
  'register.accept_required': 'Debes aceptar la Política de Privacidad y los Términos de Servicio',
  'register.password_mismatch': 'Las contraseñas no coinciden',
  'register.password_min': 'La contraseña debe tener al menos 8 caracteres',
  'register.gender_required': 'Por favor selecciona tu género',
  'register.invite_invalid': 'Código no válido',
  'register.invite_validate_error': 'No pudimos validar el código',
  'register.invite_required': 'Primero valida tu código de entrenador o gimnasio',
  'register.have_account': '¿Ya tienes cuenta?',
  'register.login': 'Iniciar sesión',

  'audit.title': 'Dashboard de Auditoría',
  'audit.subtitle': 'Monitoreo de trazabilidad y eventos críticos.',
  'audit.refresh': 'Actualizar',
  'audit.filter_level': 'Filtrar por Nivel',
  'audit.all_levels': 'Todos los niveles',
  'audit.level_info': 'Información',
  'audit.level_warn': 'Advertencias',
  'audit.level_error': 'Errores Críticos',
  'audit.trace_id': 'Buscar por Trace ID',
  'audit.trace_ph': 'Ej: ORD-12345...',
  'audit.search': 'Buscar',
  'audit.per_page': 'Por página',
  'audit.col_datetime': 'Fecha / Hora',
  'audit.col_level': 'Nivel',
  'audit.col_event': 'Evento',
  'audit.col_trace': 'Trace ID',
  'audit.col_user': 'Usuario',
  'audit.col_message': 'Mensaje',
  'audit.loading': 'Cargando registros...',
  'audit.empty': 'No se encontraron registros de auditoría.',
  'audit.user_public': 'Público',
  'audit.pagination': 'Mostrando página {page} de {totalPages} · Total: {total} registros',
  'audit.no_records': 'Sin registros',
  'audit.prev': '← Anterior',
  'audit.next': 'Siguiente →',

  'live.title': 'Clases en Vivo',
  'live.subtitle_admin': 'Programa plantillas o revisa el calendario y filtra por programa.',
  'live.subtitle_assigned': 'Calendario de tu programa asignado.',
  'live.subtitle_user': 'Agéndate en una clase y entra al Zoom desde el calendario.',
  'live.back': '← Volver',
  'live.tab_views': 'Vistas de Clases en Vivo',
  'live.tab_program': 'Programar',
  'live.tab_calendar': 'Calendario',
  'live.program_label': 'Programa:',
  'live.all_programs': 'Todos los programas',
  'live.showing': 'Mostrando: {label}',
  'live.your_program': 'Tu programa: {label}',
  'live.no_program': 'Aún no tienes un programa asignado. Habla con tu coach.',
  'live.title_admin': 'Programar clases en vivo',
  'live.subtitle_sede': 'Calendario de clases globales de tu gimnasio virtual (programas activados en la sede).',
  'live.sede_programs': 'Programas de la sede: {count}',
  'live.sede_programs_empty': 'Programas activados por el gimnasio virtual.',
  'live.filter_hint': 'Usa los filtros del calendario para encontrar tu clase.',
  'live.holiday_note': 'Los días festivos en Colombia tendrán una programación diferente.',
  'live.unsaved_confirm': 'Tienes cambios sin guardar en Programar. ¿Cambiar de pestaña sin guardar?',
  'live.host_notifications': 'Avisos de tus clases',
  'live.host_class_readonly': 'Tu clase asignada (solo lectura)',
  'live.host_class_fallback': 'Clase',
  'live.host_notice_today': 'Hoy',
  'live.host_notice_upcoming': 'Próxima',
  'live.host_notice_done': 'Finalizada',
  'live.host_notice_start': 'Iniciar reunión',
  'live.host_notice_join': 'Entrar a Zoom',
  'live.host_notice_link': 'Enlace participantes',
  'live.host_notice_copy': 'Copiar',
  'live.host_notice_copied': 'Copiado',
  'live.host_notice_hint': 'Abre la clase en el calendario para ver la rutina y registrar observaciones.',

  'schedule.title': 'Horario de clases',
  'schedule.subtitle': 'Encuentra tu método, elige el día e inscríbete',
  'schedule.search_ph': 'Buscar por método, nombre o entrenador…',
  'schedule.search': 'Buscar clases',
  'schedule.filter_class_type': 'Filtrar por tipo de clase',
  'schedule.all_class_types': 'Todos los tipos de clase',
  'schedule.class_type': 'Tipo de clase',
  'schedule.select_class_type': 'Selecciona tipo de clase',
  'schedule.filter_coach': 'Filtrar por entrenador',
  'schedule.all_coaches': 'Todos los entrenadores',
  'schedule.filter_day': 'Filtrar por día',
  'schedule.filter_date': 'Filtrar por fecha',
  'schedule.all_days': 'Todos los días',
  'schedule.weekday.monday': 'Lunes',
  'schedule.weekday.tuesday': 'Martes',
  'schedule.weekday.wednesday': 'Miércoles',
  'schedule.weekday.thursday': 'Jueves',
  'schedule.weekday.friday': 'Viernes',
  'schedule.weekday.saturday': 'Sábado',
  'schedule.weekday.sunday': 'Domingo',
  'schedule.prev_week': 'Semana anterior',
  'schedule.next_week': 'Semana siguiente',
  'schedule.time_day': 'Hora / Día',
  'schedule.am': 'A.M.',
  'schedule.pm': 'P.M.',
  'schedule.empty_week': 'No hay clases para esta semana con los filtros seleccionados.',
  'schedule.reset_week': 'Ver semana actual',
  'schedule.week_sessions': 'Sesiones de la semana',
  'schedule.spots': 'cupos',
  'schedule.no_spots': 'Sin cupos',
  'schedule.enroll': 'Inscribirme',
  'schedule.last_spot': '¡Último cupo!',
  'schedule.brand_line1': 'FIT LIVE',
  'schedule.brand_line2': 'PROGRAMA',

  'fitness_test.abdominales': 'Abdominales',
  'fitness_test.burpees': 'Burpees',
  'fitness_test.flexiones': 'Flexiones',
  'fitness_test.sentadilla': 'Sentadilla',
  'fitness_test.plancha': 'Plancha',
  'fitness_test.col_cycle': 'Ciclo / Prueba',
  'fitness_test.col_total': 'Total',
  'fitness_test.register': 'Registrar',
  'fitness_test.edit': 'Editar',
  'fitness_test.modal_title': 'Registrar prueba',
  'fitness_test.modal_hint': 'Ingresa repeticiones, peso en kg (opcional) y plancha en minutos y segundos.',
  'fitness_test.weight_kg': 'Peso usado (kg)',
  'fitness_test.weight_ph': 'Ej. 10',
  'fitness_test.reps_ph': 'Repeticiones',
  'fitness_test.plancha_min': 'Plancha — minutos',
  'fitness_test.plancha_sec': 'Plancha — segundos',
  'fitness_test.save': 'Guardar resultado',
  'fitness_test.error': 'Error',
  'fitness_test.no_wipe': 'No se puede borrar el resultado. Deja al menos una medición o cancela.',
  'fitness_test.need_one': 'Ingresa al menos una medición.',
  'fitness_test.photo_caption': 'Prueba física',
  'fitness_test.saved': 'Resultado guardado',
  'fitness_test.save_fail': 'No se pudo guardar',
  'fitness_test.burpee_type': 'Tipo de burpee (opcional)',
  'fitness_test.burpee_any': '—',
  'fitness_test.burpee_chair': 'Con silla',
  'fitness_test.burpee_mid': 'Intermedio',
  'fitness_test.burpee_full': 'Completo',
  'fitness_test.photo': 'Foto de evidencia (opcional)',
  'fitness_test.server_error': 'No se pudieron cargar las pruebas. Intenta de nuevo en unos segundos.',
  'fitness_test.loading': 'Cargando pruebas…',
  'fitness_test.pending_title': 'Pruebas no disponibles',
  'fitness_test.pending_hint': 'Cuando un administrador confirme tu pago en sede, podrás registrar medidas y resultados.',
  'fitness_test.cycle_closed_title': 'Ciclo cerrado',
  'fitness_test.cycle_closed_hint': 'El ciclo actual ya terminó. No puedes registrar nuevas medidas hasta que inicie el próximo ciclo.',
  'fitness_test.premiacion_enrolled': 'Inscrito en premiación',
  'fitness_test.premiacion_enrolled_hint': 'Participas en {name}. Sube tus fotos en la pestaña Fotos o revisa la pestaña Premiación.',
  'fitness_test.premiacion_not_enrolled': 'No inscrito en premiación',
  'fitness_test.premiacion_not_enrolled_hint': 'Puedes inscribirte en {name} desde la pestaña Premiación.',
  'fitness_test.no_test_cycle_closed': 'No hay prueba abierta porque el ciclo está cerrado.',
  'fitness_test.stats_cycles': 'Ciclos registrados',
  'fitness_test.stats_avg': 'Promedio total',
  'fitness_test.stats_best': 'Mejor ciclo',
  'fitness_test.abdominales_hint': 'Con o sin peso',
  'fitness_test.burpees_hint': 'Silla / intermedio / completo',

  'support.whatsapp': 'CONTACTAR SOPORTE',
  'support.whatsapp_hint': 'Se abrirá WhatsApp con el mensaje configurado para tu plan.',
  'support.addon.title': 'Servicios adicionales',
  'support.addon.subtitle': 'Contrata nutrición, entrenamiento o Fit Live · Programa como complemento a tu plan actual.',
  'support.addon.d28d_title': 'Fit Live · Programa',
  'support.addon.d28d_desc': 'Clases en vivo, comunidad y ciclos del programa.',
  'support.addon.food_title': 'FOOD PLAN',
  'support.addon.food_desc': 'Plan nutricional guiado, registro de alimentos y seguimiento con tu equipo.',
  'support.addon.training_title': 'Entrenamiento',
  'support.addon.training_desc': 'Rutinas personalizadas, seguimiento con coach y progreso de entrenamiento.',
  'support.addon.loading': 'Cargando servicios adicionales…',
  'support.addon.all_active': 'Ya tienes activos los servicios complementarios disponibles.',
  'support.addon.pick_plan': 'Plan',
  'support.addon.subscribe': 'Contratar y pagar',
  'support.addon.no_plan': 'Consulta con soporte para activar este servicio.',
  'support.addon.ask_whatsapp': 'Consultar por WhatsApp',
  'support.addon.checkout_title': 'Contratar',
  'support.addon.confirm': 'Confirmar',
  'support.addon.pending_title': 'Solicitud registrada',
  'support.addon.pending_msg': 'Un administrador confirmará tu pago y activará el servicio.',
  'support.addon.pending_wompi_msg': 'Completa el pago en la pestaña de Wompi. Al confirmarse se activará el servicio.',
  'support.addon.pending_food_wompi_msg': 'Completa el pago en Wompi. Tu entrenador activará FOOD PLAN cuando reciba el dinero.',
  'support.addon.renew_food_title': 'Renovar FOOD PLAN',
  'support.addon.renew_food_note': 'Tu plan venció. Completa el pago; tu entrenador activará FOOD PLAN cuando reciba el dinero.',
  'support.addon.food_checkout_note': 'Completa el pago; tu entrenador activará FOOD PLAN con el mismo email de esta cuenta.',
  'support.addon.wompi_url_missing': 'No se recibió el enlace de Wompi. Revisa los links de pago del módulo FOOD o contacta soporte.',
  'support.addon.success_title': 'Servicio contratado',
  'support.addon.success_msg': 'Tu nuevo servicio quedará disponible en unos segundos.',
  'support.addon.error_title': 'No se pudo contratar',
  'support.addon.error_msg': 'Intenta de nuevo o contacta soporte.',
  'support.addon.wa_food': 'Hola, quiero contratar FOOD PLAN como servicio adicional.',
  'support.addon.wa_training': 'Hola, quiero contratar el módulo de Entrenamiento como servicio adicional.',
  'support.addon.wa_d28d': 'Hola, quiero contratar Fit Live · Programa como servicio adicional.',
  'support.addon.password_label': 'Tu contraseña de Ecosistema Fit',
  'support.addon.password_hint': 'Misma clave con la que entras aquí',
  'support.addon.password_note': 'Se creará tu cuenta en FOOD PLAN con el mismo email y contraseña.',
  'support.addon.password_required': 'Ingresa tu contraseña actual para activar FOOD PLAN con la misma clave.',
  'support.addon.subtitle_food_only': 'Contrata FOOD PLAN (nutrición) como producto aparte de tu entrenamiento con el coach.',
  'support.addon.coach_food_wompi': 'Completa el pago en Wompi. Tu entrenador activará FOOD PLAN cuando reciba el dinero.',
  'support.subtitle': 'Preguntas frecuentes y contacto con tu equipo.',
  'support.open': 'Abrir soporte',
  'support.search_faq': 'Buscar en preguntas frecuentes…',
  'support.no_faq': 'Sin resultados.',

  'home.progress_summary': 'Tu progreso',
  'home.open_progress': 'Ver mi progreso',
  'home.progress_cta_hint': 'Adherencia, asistencia y resultados del ciclo están en Mi Progreso.',
  'home.my_nutrition': 'Alimentación',
  'home.hero.food_cta_short': 'Plan del día →',
  'home.hero.view_food': 'Ver alimentación',
  'home.library_title': 'Biblioteca',
  'home.library_hint': 'Videos por ejercicio, recientes y favoritos.',
  'home.open_gallery': 'Abrir biblioteca',
  'home.open_recordings': 'Ver grabaciones →',
  'home.spiritual_hint': 'Devocional y contenido espiritual.',
  'home.support_hint': 'FAQ, asistente y WhatsApp.',
  'home.my_training': 'Entrenamiento',
  'home.hero.training_cta_short': 'Rutina →',
  'home.live_classes': 'Clases',
  'home.open_calendar': 'Calendario →',
  'home.view_calendar': 'Ver calendario',
  'home.view_progress': 'Ver progreso',
  'home.live_classes_short': 'Clases en vivo',
  'home.more_access': 'Más accesos',
  'home.more_access_hint': 'Biblioteca, soporte y contenido adicional',
  'home.progress_empty': 'Actividad semanal',
  'home.no_progress_yet': 'Tu progreso aparecerá aquí cuando actives un servicio.',
  'home.gym_virtual': 'Gimnasio Virtual',
  'home.food_open_error': 'No se pudo abrir FOOD PLAN.',
  'home.hero.today_classes': 'Clases de hoy',
  'home.hero.day_classes': 'Clases del {day}',
  'home.hero.next_class': 'Tu próxima clase',
  'home.hero.today_class': 'Tu prioridad de hoy',
  'home.enter_zoom': 'Entrar a Zoom',
  'home.enroll_class': 'Inscribirme',
  'home.hero.training': 'Entrenamiento',
  'home.hero.continue_training': 'Continúa tu rutina',
  'home.routine_days_meta': '{days} día(s) asignados por tu coach',
  'home.hero.start_session': 'Iniciar sesión',
  'home.hero.training_done': 'Buen trabajo esta semana',
  'home.hero.training_meta': '{pct}% cumplimiento · {done}/{plan} sesiones',
  'home.hero.nutrition': 'Alimentación',
  'home.hero.food_today': 'Tu plan del día',
  'home.hero.sede_food_upsell_meta': 'Contrata FOOD PLAN desde Mi cuenta y registra tu alimentación.',
  'home.hero.food_upsell_meta': 'Contrata FOOD PLAN con tu coach y registra tu alimentación.',
  'home.hero.food_meta': 'Registra comidas y mantén tu progreso nutricional.',
  'home.hero.challenge': 'Premiación activa',
  'home.hero.challenge_meta': 'Sube tus resultados y compite en el ciclo.',
  'home.hero.view_challenge': 'Ver premiación',
  'home.hero.ascend_challenge': 'Ascender premiación',
  'home.hero.sede_welcome': 'Tu sede virtual',
  'home.hero.sede_classes': 'Clases en vivo y grabaciones',
  'home.hero.sede_meta': 'Consulta el calendario, inscríbete y revisa tu progreso.',
  'home.next_class': 'Próxima clase',
  'home.no_upcoming_class': 'No hay clases programadas próximamente',
  'home.gym_virtual_hint': 'Fit Live · Programa — consulta el calendario completo.',
  'home.d28d_session': 'Sesión en vivo',
  'home.enrolled': 'Inscrito',
  'home.active_services': 'Servicios activos',
  'myaccount.method': 'Método de Pago',

  'd28d.hub.classes': 'Clases en vivo',
  'd28d.hub.classes_hint': 'Calendario, inscripción y Zoom',
  'd28d.hub.recordings': 'Grabaciones de clase',
  'd28d.hub.recordings_hint': 'Revisa sesiones pasadas',
  'd28d.hub.progress': 'Mi progreso',
  'd28d.hub.progress_hint': 'Asistencia y avance del ciclo',
  'd28d.hub.premiacion': 'Premiación',
  'd28d.hub.premiacion_hint': 'Fotos, medidas y postulación',
  'd28d.hub.progress_sede_hint': 'Asistencia, inscripciones y clases grabadas',
  'd28d.hub.subtitle_sede': 'Clases en vivo, grabaciones y tu progreso en la sede',
  'd28d.hub.subtitle_gym': 'Todo lo que necesitas para tu transformación',
  'd28d.hub.subtitle': 'Todo lo que necesitas para tu transformación de 28 días',
  'd28d.hub.whatsapp_gym_hint': 'Escríbenos por WhatsApp cuando lo necesites',
  'd28d.hub.whatsapp_hint': 'Contacta al equipo de soporte al instante',
  'd28d.hub.title': 'Tu gimnasio virtual',
  'd28d.hub.whatsapp': 'Soporte WhatsApp',
  'd28d.hub.wa_support': 'Hola, necesito soporte',
  'd28d.hub.wa_support_gym': 'Hola, necesito soporte — {brand}',
  'd28d.hub.wa_support_d28d': 'Hola, necesito soporte de Fit Live · Programa',

  'd28d.cycle.load_error': 'No se pudo cargar tu ciclo.',
  'd28d.cycle.current': 'Ciclo activo',
  'd28d.cycle.day_of': 'Día {day} de {total}',
  'd28d.cycle.your_cycle': 'Tu ciclo',
  'd28d.cycle.days': 'días',
  'd28d.cycle.progress': 'Avance del ciclo',
  'd28d.cycle.ends': 'Finaliza',
  'd28d.cycle.remaining': 'Ciclos restantes en tu plan',
  'd28d.cycle.premiacion': 'Premiación',
  'd28d.cycle.start_video': 'Video de bienvenida',
  'd28d.cycle.start_video_label': 'Inicio de ciclo',
  'd28d.cycle.start_video_title': 'Mensaje de bienvenida — {cycle}',
  'd28d.cycle.start_video_hint': 'Toca para ver el video en pantalla completa.',
  'd28d.cycle.start_video_link_hint': 'Toca para abrir el video.',
  'd28d.cycle.start_video_modal_title': 'Bienvenida — {cycle}',

  'recording.default_title': 'Grabación',
  'recording.embed_fail': 'No se puede incrustar este enlace. Ábrelo en una pestaña nueva.',
  'recording.zoom_open_hint': 'Las grabaciones de Zoom no se pueden reproducir dentro de la app. Ábrelas en Zoom (pestaña nueva). Si Zoom pide clave o dice que no existe, revisa en tu cuenta Zoom que la grabación siga publicada y la contraseña de compartir.',
  'recording.embed_platforms': 'Para ver el video dentro de la app usa YouTube o Vimeo.',
  'recording.open_zoom': 'Abrir grabación en Zoom',
  'recording.open_link': 'Abrir enlace',

  'spiritual.open_aria': 'Abrir Viento Recio',
  'spiritual.home_hint': 'Biblia · Devocional · Hoy',

  'register.step3_title': 'Elige tu plan',
  'register.no_plans': 'No hay planes activos para este programa. Contacta a tu gimnasio o a soporte.',
  'register.couple_plan_badge': 'Plan de pareja (2 usuarios)',

  'live.admin.confirm_delete': '¿Eliminar esta clase en vivo?',
  'live.admin.confirm_import_catalog': '¿Importar plantillas del catálogo base? (omite duplicados)',
  'live.admin.delete_error': 'Error eliminando la clase.',

  'vigencias.extend_title': 'Ampliar vigencia',
  'vigencias.extend_for_user': 'Usuario',
  'vigencias.days_quick': 'Días rápidos',
  'vigencias.days_custom': 'Días personalizados',
  'vigencias.days_placeholder': 'Ej. 30',
  'vigencias.days_hint': 'Entre 1 y 365 días. Se suman a la vigencia actual del plan.',
  'vigencias.extend_confirm': 'Ampliar {n} días',

  'users.mark_pending_title': 'Marcar pago pendiente',
  'users.mark_pending_hint': 'Indica cuántos días tendrá el usuario para completar el pago. Al llegar la fecha se enviará recordatorio y podrás contactarlo por WhatsApp.',
  'users.pending_days': 'Días para pagar',
  'users.pending_due': 'Fecha límite',
  'users.preview_whatsapp': 'Vista previa mensaje WhatsApp',
  'users.no_phone_whatsapp': 'Este usuario no tiene teléfono registrado para WhatsApp.',
  'users.phone_hint': 'Incluye el indicativo del país para habilitar WhatsApp (ej. Colombia +57).',
  'users.mark_pending_confirm': 'Marcar pendiente',

  'd28d.recordings.empty': 'Aún no hay grabaciones publicadas para tu programa.',
  'd28d.recordings.open_gallery': 'Abrir grabaciones',
  'd28d.recordings.see_all': 'Ver todas',
  'd28d.recordings.home_hint': 'Toca una clase para abrir la grabación.',
  'd28d.recordings.untitled': 'Clase grabada',

  'd28d.progress.unavailable': 'Progreso no disponible',
  'd28d.progress.attended': 'Asistidos',
  'd28d.challenges.sidebar': 'Retos y eventos',
  'd28d.challenges.sidebar_hint': 'Participa en eventos del gimnasio virtual cuando estén activos.',

  'mi_progreso.subtitle_sede': 'Tu asistencia, inscripciones y clases en vivo de {brand}.',
  'mi_progreso.your_gym': 'tu sede',
  'mi_progreso.summary_title': 'Resumen personal',
  'mi_progreso.summary_hint': 'Tu avance de la semana en un vistazo. Abre cada pestaña para el detalle.',
  'mi_progreso.results_title': 'Tu actividad',
  'mi_progreso.results_hint': 'Asistidos (Zoom), días del plan e inscripciones. Pruebas y fotos están en sus pestañas.',
  'mi_progreso.results_hint_sede': 'Asistidos (Zoom), días del plan e inscripciones. El detalle de clases está en la pestaña Clases.',
  'mi_progreso.tests_hint_short': 'Registro por ciclo y fotos de progreso en sus pestañas.',
  'mi_progreso.open_tests': 'Abrir pruebas',
  'mi_progreso.open_photos': 'Abrir fotos',
  'mi_progreso.tab.general': 'Progreso General',
  'mi_progreso.tab.alimentacion': 'Alimentación',
  'mi_progreso.tab.entrenamiento': 'Entrenamiento',
  'mi_progreso.tab.clases': 'Clases',
  'mi_progreso.tab.pruebas': 'Pruebas físicas',
  'mi_progreso.tab.premiacion': 'Premiación',
  'mi_progreso.attendance_title': 'Asistencia',
  'mi_progreso.sede_attendance_hint': 'Consulta el calendario de clases, inscríbete y revisa tus grabaciones.',
  'mi_progreso.attendance_hint': 'Resumen de clases a las que has asistido.',
  'mi_progreso.measures_training_tab_hint': 'Las medidas corporales están en la pestaña Medidas, separadas de tu rutina.',
  'mi_progreso.food_summary_hint': 'Resumen nutricional en FOOD PLAN. Abre la plataforma para registrar comidas.',
  'mi_progreso.coach_title': 'Mi coach',
  'mi_progreso.connecting': 'Conectando…',

  'account.pending_title': 'Servicio pendiente de activación',
  'account.pending_hint': 'Mientras tanto solo puedes revisar Mi Cuenta y Soporte. Cuando un administrador active tu acceso, se habilitarán clases, progreso y demás funciones.',
  'account.pending_payment': 'Tu servicio está pendiente de activación. Un administrador de la plataforma o de tu gimnasio debe habilitarlo antes de usar las funciones.',
  'account.pending_futbol': 'Tu escuela de fútbol está pendiente de activación. Un administrador de futbol.app o de tu escuela debe habilitarlo.',
  'account.pending_cycle_renewal': 'Tu ciclo terminó. Renueva tu plan para continuar con el siguiente ciclo. El acceso está restringido hasta confirmar el pago.',
  'account.pending_coach_client': 'Tu entrenamiento está pendiente de activación. Tu coach debe pagar vía Wompi desde «Activar clientes» antes de que puedas usar el perfil.',
  'account.pending_coach_hint': 'Mientras tanto solo puedes usar Mi Cuenta (para contratar FOOD PLAN con Wompi) y Soporte. El entrenamiento, biblioteca y progreso se habilitan cuando tu coach active tu acceso.',
  'account.pending_coach_title': 'Bienvenido/a a {brand}',
  'myaccount.food_wompi_while_pending': 'Tu entrenamiento sigue pendiente, pero puedes contratar FOOD PLAN aquí y pagar en línea con Wompi.',

  'myaccount.cycle_gym': 'Ciclo',
  'myaccount.gym_code': 'Código de invitación',
  'myaccount.gym_code_copied': 'Código copiado',
  'myaccount.gym_code_hint': 'Comparte este código cuando quieras registrar usuarios dentro del gimnasio asociado.',
  'myaccount.coach_code': 'Código de invitación',
  'myaccount.coach_code_hint': 'Código de tu coach (marca blanca). Compártelo para registrar clientes de entrenamiento.',
  'myaccount.avatar_too_large': 'Imagen demasiado grande',
  'myaccount.avatar_max': 'Máximo 2 MB',
  'myaccount.avatar_saved': 'Foto de perfil actualizada',
  'myaccount.avatar_error': 'No se pudo subir la foto',
  'myaccount.avatar_uploading': 'Subiendo…',
  'myaccount.change_avatar': 'Cambiar foto de perfil',
  'myaccount.active_services': 'Servicios activos',
  'myaccount.current_plan': 'Plan actual',
  'myaccount.renew': 'Renovar',
  'myaccount.expires': 'Vence',
  'myaccount.gym': 'Sede',
  'myaccount.trainer': 'Entrenador',
  'myaccount.sessions_left': 'Sesiones Restantes',
  'myaccount.no_active': 'No tienes una suscripción activa.',
  'myaccount.choose_plan': 'Elige tu plan',
  'myaccount.subscribe': 'Contratar',
  'myaccount.mydata': 'Mis Datos',
  'myaccount.birthdate': 'Fecha de Nacimiento',
  'myaccount.objective': 'Objetivo',
  'myaccount.save': 'Guardar Cambios',
  'myaccount.security': 'Seguridad',
  'myaccount.current_password': 'Contraseña actual',
  'myaccount.new_password': 'Nueva contraseña',
  'myaccount.confirm_password': 'Confirmar contraseña',
  'myaccount.change_password': 'Cambiar contraseña',
  'myaccount.subscribe_plan': 'Contratar Plan',
  'myaccount.confirm_and_pay': 'Confirmar y Pagar',
  'myaccount.confirm': 'Confirmar',
  'myaccount.not_available': 'N/A',

  'schedule.class_closed': 'Cerrada',
  'schedule.class_closed_label': 'Clase cerrada',
  'schedule.enrollment_closed': 'Inscripción cerrada',
  'schedule.enrollment_closed_detail': 'Esta clase ya terminó o la inscripción no está disponible.',
  'schedule.zoom_pending': 'El enlace Zoom estará disponible antes de la clase.',
  'schedule.zoom_pending_trainer': 'Tu entrenador publicará el enlace Zoom antes de la clase.',
  'schedule.enroll_fail': 'Inscripción',
  'schedule.enroll_error': 'No se pudo completar la inscripción',
  'schedule.enroll_ok_title': 'Inscripción confirmada',
  'schedule.enroll_ok_msg': 'Excelente, has quedado registrado. Recuerda conectarte 5 minutos antes.',
  'schedule.enroll_ok_named': 'Excelente, has quedado registrado para la clase {title}. Recuerda conectarte 5 minutos antes, nos vemos en clase.',
  'schedule.enroll_chip_note': 'Registrado · conéctate 5 min antes',
  'schedule.no_zoom': 'Sin enlace Zoom',
  'schedule.enrolled': 'Inscripción confirmada',
  'schedule.no_zoom_trainer_hint': 'Tu entrenador aún no ha publicado el enlace. Revisa de nuevo más cerca de la hora de la clase.',
  'schedule.spots_available': '{count} disponibles',
  'schedule.last_spot_suffix': ' · ¡Último cupo!',
  'schedule.default_class': 'Clase en vivo',
  'schedule.default_coach': 'Entrenador',
  'schedule.attendance': 'Asistencia',
  'schedule.zoom_brand': 'Zoom',

  'coach.food_panel_subtitle': 'Panel profesional FOOD PLAN — seguimiento de tus asesorados.',
  'myaccount.payment_wompi': 'Pago en línea (Wompi)',
  'myaccount.payment_sede': 'Pago en sede',

  'help.title': 'Ayuda',
  'help.assistant_title': 'Asistente {module}',
  'help.placeholder': '¿En qué te ayudo?',
  'help.no_exact_match': 'No encontré una respuesta exacta.',
  'help.contact_whatsapp': 'Contactar soporte WhatsApp',
  'help.wa_message': 'Hola, necesito ayuda ({module}): {query}',

  'chat.title': 'Asistente nutricional',
  'chat.plan_line': 'Plan diario: {kcal} kcal · P {p}g · C {c}g · G {g}g',
  'chat.prefs': 'Preferencias',
  'chat.hide_prefs': 'Ocultar prefs',
  'chat.open': 'Abrir asistente nutricional',
  'chat.placeholder': 'Escribe tu pregunta...',
  'chat.send': 'Enviar',
  'chat.prefs_saved': 'Preferencias guardadas.',
  'chat.close': 'Cerrar',
  'chat.assistant_btn': 'Asistente',
  'chat.save_prefs': 'Guardar preferencias',
  'appearance.lang_es': 'Español (ES)',
  'appearance.lang_en': 'English (EN)',
};

export const DASHBOARD_I18N_EN = {
  'nav.masters': 'Masters',
  'nav.audit': 'Audit',
  'nav.appearance': 'Appearance',
  'nav.paymentlinks': 'Payments',
  'nav.liveclasses': 'Live Classes',
  'nav.myplan': 'My Plan',
  'nav.training': 'Training',
  'nav.companies': 'Companies',
  'nav.mybrand': 'My Brand',
  'nav.programs_d28d': 'Fit Live · Programs',
  'nav.gallery': 'Gallery',
  'nav.gallery_classes': 'CLASS RECORDINGS',
  'nav.gallery_exercises': 'Exercise library',
  'nav.routines': 'Routines',
  'nav.routine_templates': 'Templates',
  'nav.planning': 'Planning',
  'nav.tracking': 'Tracking',
  'nav.coach_ai': 'AI Assistant',
  'nav.assign_plans': 'Assign plans',
  'nav.edit_routines': 'Edit routines',
  'coach.routines.title': 'Edit routines',
  'coach.routines.subtitle': 'Create routines (library), assign them to clients, and edit assigned ones. Each day can be Gym or Sports (Running / Swim).',
  'coach.routines.assigned_heading': 'Assigned routines',
  'coach.routines.library_tab': 'Routines',
  'coach.routines.search_ph': 'Search by client, ID or level…',
  'coach.routines.empty_title': 'No routines assigned yet',
  'coach.routines.empty_body': 'Create a routine in the Routines tab (or AI Assistant), then assign it. Edit assigned plans here.',
  'coach.routines.go_ai': 'Go to AI Assistant',
  'coach.routines.go_clients': 'View my users',
  'coach.routines.go_activate': 'Activate clients',
  'coach.routines.editor_hint': 'Choose Edit in Routines or Assigned routines.',
  'coach.routines.sport_hint': 'Each day is independent: gym, Running or Swim. Adding days does not delete existing ones; you can add gym or sport work and delete a day if needed.',
  'nav.trainers_admin': 'Trainers',
  'nav.coach_users': 'Coach clients',
  'panel.back_panel': '← Panel',
  'nav.myusers': 'My Users',
  'nav.nutrition_plans': 'Nutrition Plans',
  'nav.foods_catalog': 'Foods',
  'nav.vigencias': 'Subscriptions',
  'nav.assistant': 'Assistant',
  'nav.liveclasses_short': 'Classes',
  'nav.plans_short': 'Plans',
  'nav.gyms': 'Gyms',
  'nav.tenants': 'Tenants',
  'nav.mi_progreso': 'My Progress',
  'nav.support': 'Support',
  'nav.services': 'Services',
  'nav.tracking_training': 'Training tracking',
  'nav.tracking_food': 'Food tracking',
  'nav.host_daily': 'My day',
  'nav.organizations': 'Organizations',
  'nav.commercial_plans': 'Commercial plans',
  'nav.spiritual': 'Viento Recio',
  'nav.photos_measurements': 'Photos & measurements',
  'nav.activate_clients': 'Activate clients',
  'nav.training_pending': 'Pending training',

  'status.activo': 'Active',
  'status.vigente': 'Active',
  'status.por_vencer': 'Expiring soon',
  'status.pendiente': 'Pending',
  'status.pendiente_sede': 'Pending (gym payment)',
  'status.pendiente_pago_online': 'Pending (online payment)',
  'status.vencido': 'Expired',
  'status.cancelado': 'Cancelled',
  'status.en_proceso': 'In progress',
  'status.rechazado': 'Rejected',
  'status.active': 'Active',
  'status.published': 'Published',

  'service.d28d': 'Fit Live · Programa',
  'service.food': 'FOOD PLAN',
  'service.training': 'TRAINING',

  'payment.wompi_online': 'Online payment (Wompi)',
  'payment.pago_sede': 'Pay at gym',
  'payment.pago_pendiente': 'Pending payment (manual activation)',

  'myaccount.profile': 'My Profile',
  'myaccount.my_services': 'My Services',
  'myaccount.my_coach': 'My coach',
  'myaccount.plan_duration': 'Validity',
  'myaccount.plan_duration_days': '{days} calendar days',
  'myaccount.food_plans': 'Available FOOD plans',
  'myaccount.program': 'Program',
  'myaccount.plan_label': 'Plan',
  'myaccount.start_date': 'Start',
  'myaccount.cycle_d28d': 'Fit Live · Programa cycle',
  'myaccount.none_trainer': 'None',
  'myaccount.weight': 'Weight (kg)',
  'myaccount.height': 'Height (cm)',
  'myaccount.objective_maintenance': 'Maintenance',
  'myaccount.objective_fatloss': 'Fat Loss',
  'myaccount.objective_muscle': 'Muscle Gain',
  'myaccount.per_month': '/ month',
  'myaccount.couple_plan': 'Couple plan — includes code for a 2nd person',
  'myaccount.plan_hint': 'You can choose gym, trainer, both, or neither. Only the plan is required.',
  'myaccount.cycle_select': 'Fit Live · Programa cycle',
  'myaccount.cycle_select_ph': 'Select cycle',
  'myaccount.gym_optional': 'Gym (optional)',
  'myaccount.trainer_optional': 'Trainer (optional)',
  'myaccount.couple_code_title': 'Code for your partner (one-time use)',
  'myaccount.copy_code': 'Copy code',
  'myaccount.couple_code_hint': 'Share it at registration; they inherit plan, program, and validity.',
  'myaccount.linked_account': 'Account linked to couple plan (guest).',
  'myaccount.whatsapp_support': 'WhatsApp support',
  'myaccount.toast.copied': 'Copied',
  'myaccount.toast.couple_copied': 'Couple code copied to clipboard',
  'myaccount.toast.copy_manual': 'Copy the code manually',
  'myaccount.toast.sub_active': 'Subscription activated',
  'myaccount.toast.plan_active': 'Plan {plan} active',
  'myaccount.toast.pending': 'Request submitted',
  'myaccount.toast.success': 'Subscription successful',
  'myaccount.toast.pending_msg': 'Your coach or admin will confirm gym payment, or complete Wompi in the opened tab.',
  'myaccount.toast.plan_activated': 'Plan {plan} activated',
  'myaccount.toast.profile_ok': 'Profile updated',
  'myaccount.toast.profile_saved': 'Your data was saved',
  'myaccount.toast.profile_error': 'Could not update profile',
  'myaccount.toast.subscribe_error': 'Subscription error',
  'myaccount.acquire_food': 'Get FOOD PLAN',
  'myaccount.acquire_services': 'Get other services',
  'myaccount.food_not_contracted': 'You do not have FOOD PLAN yet. Subscribe here to track your nutrition with your coach.',
  'myaccount.food_pending_title': 'FOOD PLAN pending payment',
  'myaccount.food_pending_hint': 'Your request is registered. Complete online payment (Wompi) or wait for your coach to confirm activation.',
  'myaccount.food_active_title': 'FOOD PLAN active',
  'myaccount.food_active_hint': 'Your nutrition plan is active. Open it from Home or My Progress → Nutrition.',

  'common.current': 'Your Current Plan',
  'common.roles': 'Permissions',

  'mi_progreso.subtitle': 'Your progress in nutrition, training, and Fit Live · Programa in one place.',
  'mi_progreso.subtitle_d28d': 'Your progress, live classes, and enrollments in one place.',
  'mi_progreso.subtitle_coach': 'Your progress in nutrition and training with {brand}.',
  'mi_progreso.subtitle_training_brand': 'Your routine, measurements, and progress with {brand}.',
  'mi_progreso.your_coach': 'your coach',
  'mi_progreso.tab.pruebas_fitness': 'Fitness tests',
  'mi_progreso.food_external_hint': 'Your food log and nutrition assistant live in the FOOD PLAN platform.',
  'mi_progreso.training_external_hint': 'Open your training panel in the dedicated app.',
  'mi_progreso.tab.resumen': 'Progress',
  'mi_progreso.tab.entrenamiento': 'Training',
  'mi_progreso.tab.clases': 'Live classes',
  'mi_progreso.tab.medidas': 'Measurements & photos',
  'mi_progreso.tab.fotos': 'Photos',
  'mi_progreso.tab.measures': 'Body measurements',
  'mi_progreso.tab.pruebas': 'Fitness tests',
  'mi_progreso.tab.habitos': 'Habits',
  'mi_progreso.tab.habitos_wellness': 'Wellness',
  'mi_progreso.measures_training_hint': 'Log body measurements and progress photos with your coach.',
  'wellness.intro': 'Tell us how you feel today: sleep, stress, energy, and appetite. Your coach uses this to adjust your plan.',
  'wellness.intro_short': 'Daily sleep, stress, and energy check-in.',
  'wellness.open': 'Complete survey',
  'wellness.save': 'Save today\'s survey',
  'wellness.saved': 'Survey saved',
  'wellness.saved_hint': 'Your wellness log was recorded for today.',
  'wellness.error': 'Error',
  'wellness.save_fail': 'Could not save survey',
  'wellness.last_saved': 'Last saved',
  'wellness.sleep_hours': 'Sleep (hours)',
  'wellness.sleep_quality': 'Sleep quality',
  'wellness.stress': 'Stress',
  'wellness.appetite': 'Appetite',
  'wellness.energy': 'Energy',
  'wellness.soreness': 'Soreness / DOMS',
  'mi_progreso.tab.asistencia': 'Attendance',
  'mi_progreso.tab.eventos': 'Events',
  'mi_progreso.tab.logros': 'Achievements',
  'mi_progreso.tab.pruebas': 'Physical tests',
  'mi_progreso.tab.premiacion': 'Awards',
  'mi_progreso.tests_title': 'Physical tests',
  'mi_progreso.tests_hint': 'Record crunches, burpees, push-ups, squats, and plank by cycle.',
  'mi_progreso.open_tests': 'View my tests',
  'mi_progreso.measures_title': 'Measurements & photos',
  'mi_progreso.measures_hint': 'Anthropometry and progress photos in one place.',
  'progress_photos.slots_hint': 'Upload 4 progress photos (front, right side, back, and left side).',
  'progress_photos.slot_front': 'Front',
  'progress_photos.slot_side': 'Right side',
  'progress_photos.slot_back': 'Back',
  'progress_photos.slot_detail': 'Left side',
  'progress_photos.phase_start': 'Cycle start',
  'progress_photos.phase_end': 'Cycle end',
  'progress_photos.tap_upload': 'Tap to upload',
  'progress_photos.tap_replace': 'Tap a slot to upload, change, or delete',
  'progress_photos.delete': 'Delete',
  'progress_photos.deleting': 'Deleting…',
  'progress_photos.deleted': 'Photo deleted',
  'progress_photos.delete_confirm': 'Delete this photo? You can upload another one.',
  'progress_photos.delete_fail': 'Could not delete photo',
  'progress_photos.uploading': 'Uploading…',
  'progress_photos.saved': 'Photo saved',
  'progress_photos.error': 'Error',
  'progress_photos.too_large': 'The image is too large. Use a photo up to 15 MB or compress it.',
  'progress_photos.upload_fail': 'Could not upload',
  'progress_photos.loading': 'Loading photos…',
  'progress_photos.cycle_closed_title': 'Cycle closed',
  'progress_photos.cycle_closed_hint': 'The current cycle has ended. You cannot upload new photos until the next cycle.',
  'progress_photos.premiacion_enrolled': 'Enrolled in challenge',
  'progress_photos.premiacion_not_enrolled': 'Not enrolled in challenge',
  'progress_photos.progress_count': '{count} of {total} photos',
  'progress_photos.enlarge': 'View full-size photo',
  'progress_photos.pending': 'Pending',
  'progress_photos.upload_slot': 'Upload {slot} photo',
  'progress_photos.replace_short': 'Change',
  'progress_photos.hint': 'Upload progress photos (front, profile or detail) to track your evolution.',
  'progress_photos.caption': 'Note (optional)',
  'progress_photos.caption_ph': 'e.g. Week 4 — front',
  'progress_photos.upload': 'Upload photo',
  'progress_photos.empty': 'You have no progress photos yet.',
  'progress_photos.default_alt': 'Progress',
  'progress_photos.slots_hint_cycle': 'Upload 4 photos at cycle start and 4 at the end (front, right side, back, and left side).',
  'mi_progreso.open_measures': 'Log measurements',
  'mi_progreso.live_classes_title': 'Live classes',
  'mi_progreso.live_classes_hint': 'Check the schedule, enroll, and join Zoom when the session starts.',
  'mi_progreso.open_live_classes': 'View classes & enroll',
  'mi_progreso.food_legacy_hint': 'Your daily food log is in FOOD_PLAN from Home → FOOD_PLAN.',
  'mi_progreso.photos_title': 'Progress photos',
  'mi_progreso.food_habits': 'Meal logging, measurements, and nutrition chat live in FOOD_PLAN.',
  'mi_progreso.open_food': 'Go to Food Plan',
  'mi_progreso.open_training': 'Open training',
  'mi_progreso.training_dashboard_title': 'My training dashboard',
  'mi_progreso.training_dashboard_hint': 'Daily routine, set logging, and your coach video gallery.',
  'mi_progreso.open_training_dashboard': 'Open training',
  'mi_progreso.no_habits': 'No active habit modules.',
  'mi_progreso.logros_hint': 'Complete events in the Events tab to unlock podiums and recognition.',

  'd28d.progress.title': 'Fit Live · Programa summary',
  'd28d.progress.traffic_light': 'Traffic light',
  'd28d.progress.traffic.green': 'Green',
  'd28d.progress.traffic.yellow': 'Yellow',
  'd28d.progress.traffic.red': 'Red',
  'd28d.tracking.traffic_title': 'Traffic-light alerts (adherence)',
  'd28d.tracking.traffic_optin': 'Send in_app/email traffic-light alerts to Fit Live · Programa users (opt-in)',
  'd28d.tracking.traffic_hint': 'Off by default. Requires D28D_TRAFFIC_LIGHT_JOB on the server.',
  'd28d.tracking.traffic_saved': 'Saved',
  'd28d.tracking.traffic_save_error': 'Could not save',
  'd28d.progress.attendance': 'Attendance',
  'd28d.progress.events': 'Events',
  'd28d.progress.enrolled': 'Enrolled',
  'd28d.progress.completed': 'Completed',
  'd28d.progress.won': 'Won',
  'd28d.progress.adherence': 'Your weekly progress',
  'd28d.progress.active_days': 'Active days',
  'd28d.progress.plan_days': 'Plan days',
  'd28d.progress.results_title': 'Cycle results',
  'd28d.progress.attendance_pct': 'Attendance %',
  'd28d.progress.cycle_pct': 'Cycle progress',
  'd28d.progress.premiacion_yes': 'Enrolled',
  'd28d.progress.premiacion_open': 'Available',
  'd28d.progress.last_weight': 'Latest weight',
  'd28d.progress.compare_classes': 'Enrolled vs attended',
  'd28d.progress.weight_trend': 'Weight trend',
  'd28d.progress.validity': 'Validity',
  'd28d.progress.validity_active': 'Active',
  'd28d.progress.validity_pending': 'Pending activation',
  'd28d.progress.loading': 'Loading progress…',
  'd28d.progress.load_error': 'Could not load your program progress.',

  'd28d.challenges.title': 'Events',
  'd28d.challenges.enrolled_ok': 'Enrollment confirmed',
  'd28d.challenges.withdrawn': 'You withdrew from the challenge',
  'd28d.challenges.evidence_sent': 'Evidence submitted',
  'd28d.challenges.file_uploaded': 'File uploaded',
  'd28d.challenges.prize': 'Prize',
  'd28d.challenges.status': 'Status',
  'd28d.challenges.join': 'Join',
  'd28d.challenges.withdraw': 'Withdraw',
  'd28d.challenges.upload_evidence': 'Upload evidence',
  'd28d.challenges.comment_ph': 'Comment or text',
  'd28d.challenges.send_text': 'Send text',
  'd28d.challenges.file': 'File',
  'd28d.challenges.winners': 'Winners',
  'd28d.challenges.ranking': 'Ranking',

  'training.progress.loading': 'Loading training compliance…',
  'training.progress.title': 'My Training compliance',
  'training.progress.traffic': 'Traffic light',
  'training.progress.adherence_7d': '7-day compliance',
  'training.progress.sessions': 'Sessions',

  'services.greeting': 'Hello, {name}',
  'services.greeting_short': 'Hello',
  'services.no_services': 'You have no active services on {brand} yet. Contact your coach or gym team to enable them.',
  'services.title_multi': 'YOUR SERVICES',
  'services.title_single': 'YOUR SPACE',
  'services.welcome_multi': 'Welcome to {brand}. Open the module you want to review today.',
  'services.welcome_single': 'Welcome to {brand}.',
  'services.open_aria': 'Open {title}',

  'masters.title': 'SYSTEM MASTERS',
  'masters.subtitle': 'Manage catalogs and content for the three ecosystem services.',
  'masters.open_aria': 'Open master {title}',

  'panel.back_services': '← Services',
  'panel.back_home': '← Back to home',
  'panel.open': 'Open',
  'panel.active_programs': 'Active programs',
  'panel.operation': 'Operations',
  'panel.d28d_masters': 'Virtual gym masters',
  'panel.d28d_masters_desc': 'Seed virtual-gym catalog and settings: routine templates, commercial plans and appearance. Day-to-day ops stay under Operations above.',
  'panel.white_label_gyms': 'White-label gyms',
  'panel.white_label_desc_admin': 'White-label gyms consume Fit Live · Programa content and schedule on live class templates.',
  'panel.white_label_desc_user': 'Your gym consumes Fit Live · Programa content and schedules on live class templates.',

  'panel.food-plan.cards.adminusers.title': 'Users',
  'panel.food-plan.cards.adminusers.desc': 'People with an assigned nutrition plan.',
  'panel.food-plan.cards.admin.title': 'Configure plans',
  'panel.food-plan.cards.admin.desc': 'Define or adjust each user’s plan.',
  'panel.food-plan.cards.progress.title': 'Tracking',
  'panel.food-plan.cards.progress.desc': 'Nutrition compliance and progress.',
  'panel.food-plan.cards.calculator.title': 'Nutrition calculator',
  'panel.food-plan.cards.calculator.desc': 'Calculate an initial reference for the user.',
  'panel.food-plan.cards.foodsmanager.title': 'Food catalog',
  'panel.food-plan.cards.foodsmanager.desc': 'Food list, macros and reference portions.',
  'panel.food-plan.cards.foodlog.title': 'Food log',
  'panel.food-plan.cards.foodlog.desc': 'Users’ nutrition diary.',
  'panel.food-plan.cards.equivalentes.title': 'Group equivalents',
  'panel.food-plan.cards.equivalentes.desc': 'Swaps while keeping macros.',
  'panel.food-plan.cards.recipes.title': 'Recipes',
  'panel.food-plan.cards.recipes.desc': 'Healthy recipe library.',
  'panel.food-plan.cards.modulevigencias.title': 'Subscriptions',
  'panel.food-plan.cards.modulevigencias.desc': 'Payment confirmation and license extensions.',

  'panel.training.cards.training.title': 'My training',
  'panel.training.cards.training.desc': 'Today’s routine with assisted substitutions.',
  'panel.training.cards.coachroutines.title': 'Routine templates',
  'panel.training.cards.coachroutines.desc': 'D28D-style editor: blocks, exercises, videos (your routines only).',
  'panel.training.cards.coachai.title': 'AI Assistant',
  'panel.training.cards.coachai.desc': 'Build routines and plans from your gallery (free local engine).',
  'panel.training.cards.admintraining.title': 'Planning',
  'panel.training.cards.admintraining.desc': 'Per-user plans, days and training log.',
  'panel.training.cards.admingallery.title': 'Video gallery',
  'panel.training.cards.admingallery.desc': 'Exercise videos (visual reference).',
  'panel.training.cards.adminusers.title': 'Assigned users',
  'panel.training.cards.adminusers.desc': 'People list and assigned routines.',
  'panel.training.cards.progress.title': 'Tracking',
  'panel.training.cards.progress.desc': 'Adherence and user progress.',

  'panel.gym.cards.admingyms.title': 'My brand',
  'panel.gym.cards.admingyms.desc': 'Logo, colors, message and support WhatsApp.',
  'panel.gym.cards.adminusers.title': 'Users',
  'panel.gym.cards.adminusers.desc': 'Sign-ups, roles and module licenses.',
  'panel.gym.cards.adminplans.title': 'Subscriptions',
  'panel.gym.cards.adminplans.desc': 'Accounts and expiry dates.',
  'panel.gym.cards.liveclasses.title': 'Live classes',
  'panel.gym.cards.liveclasses.desc': 'Fit Live · Programa live classes enabled for your gym.',

  'gym.masters.brand': 'My brand & contact',
  'gym.masters.brand_desc': 'Logo, colors, email, phone and WhatsApp for your gym.',
  'gym.masters.plans': 'Commercial plans',
  'gym.masters.plans_desc': 'Create subscription plans for your gym and assign them to programs and cycles.',
  'gym.masters.plans_help': 'Define commercial plans (price, name, modules). Create cycles and programs under Masters first, then assign them when creating each plan.',
  'gym.masters.cycles': 'Cycles',
  'gym.masters.cycles_desc': 'Cycle calendar for your gym (custom start and end dates).',
  'gym.masters.programs': 'Programs',
  'gym.masters.programs_desc': 'Your gym\'s own programs to link to plans.',
  'gym.programs.configure': 'Configure',
  'gym.masters.routines': 'Routines',
  'gym.masters.routines_desc': 'Routine templates for live classes at your gym.',
  'gym.masters.challenges': 'Challenges',
  'gym.masters.challenges_desc': '28-day cycle awards for users at your gym.',
  'gym.masters.open_hub': 'Open my gym Masters →',
  'gym.masters.cycles_desc_linked': 'Set each cycle period with start and end dates, link your gym programs, then assign them in Plans.',
  'gym.cycles.end': 'End date',
  'gym.cycles.duration': 'Duration',
  'gym.cycles.days': 'days',
  'gym.cycles.end_required': 'Enter the cycle end date.',
  'gym.cycles.end_before_start': 'End date must be on or after the start date.',
  'gym.cycles.programs_in_cycle': 'Programs in this cycle',
  'gym.cycles.select_all_programs': 'Select all',
  'gym.cycles.clear_programs': 'Clear all',
  'gym.cycles.need_programs': 'Create programs under Masters → Programs before linking them to cycles.',
  'gym.cycles.no_programs_yet': 'No programs at your gym yet.',
  'gym.masters.users_title': 'Users of {gym}',
  'gym.masters.users_subtitle': 'Only people registered at your virtual gym.',
  'gym.plans.need_programs': 'Create a program under Masters → Programs before linking it to a plan.',
  'gym.programs.new': 'New program',
  'gym.programs.name': 'Program name',
  'gym.programs.color': 'Color',
  'gym.programs.active_cycle': 'Active cycle',
  'gym.programs.active': 'Active',
  'gym.programs.none': 'No programs yet. Create the first one for your gym.',
  'gym.programs.need_cycles': 'Create at least one cycle under Masters → Cycles first.',
  'gym.programs.created': 'Program created',
  'gym.programs.updated': 'Program updated',
  'gym.programs.deleted': 'Program deleted',
  'gym.programs.delete_confirm': 'Delete this program?',
  'gym.programs.delete_error': 'Could not delete program',
  'gym.programs.save_error': 'Error saving program',
  'gym.programs.error_loading': 'Error loading programs',
  'gym.programs.name_required': 'Program name is required',
  'gym.programs.zoom': 'Zoom',
  'gym.programs.zoom_pending': 'Not configured',
  'gym.masters.plans_page_lead': 'commercial plans for your gym',
  'gym.masters.plans_embedded_hint': 'Create a plan with «Create plan» and select included cycles in the form.',
  'gym.masters.users_desc': 'People at your gym, access and daily operations.',
  'gym.masters.trainers': 'Trainers',
  'gym.masters.trainers_desc': 'Your gym\'s trainers (gym trainer role): live classes, routines and Zoom.',
  'gym.masters.live_desc': 'Schedule live classes and attendance.',
  'gym.masters.gallery_desc': 'Recordings and links from classes at your gym.',
  'gym.gallery.title': 'CLASS RECORDINGS for your gym',
  'gym.gallery.subtitle': 'Recordings and links from live classes at your virtual gym. Only visible to users at your location.',
  'gym.gallery.need_program': 'Create a program under Masters → Programs before publishing recordings.',
  'gym.masters.vigencias_desc': 'Licences, pending payments and renewals.',
  'gym.masters.subtitle': 'Configure your virtual gym: brand, plans, users, trainers and classes.',
  'gym.masters.plans_active': 'active plans',
  'gym.masters.plans_pending': 'no plans configured yet',
  'gym.masters.your_gym': 'Your virtual gym',
  'nav.users': 'Users',
  'finance.card': 'Financial summary',
  'finance.title': 'Financial summary',
  'finance.title.coach': 'My affiliates finance',
  'finance.subtitle_coach': 'Same Training board, only revenue and KPIs for your affiliates.',
  'nav.finance_coach': 'Affiliate finance',
  'finance.subtitle': 'Confirmed payments, licenses, churn and expenses — super_admin only.',
  'finance.home_preview': 'Current month (COP). Open the board for charts, drill-down and expenses.',
  'finance.open_board': 'Open board',
  'finance.back': 'Back to home',
  'finance.refresh': 'Refresh',
  'finance.period.month': 'Current month',
  'finance.period.last12': 'Last 12 months',
  'finance.kpi.revenue': 'Revenue',
  'finance.kpi.expenses': 'Expenses',
  'finance.kpi.net': 'Net',
  'finance.kpi.active': 'Active',
  'finance.kpi.inactive': 'Inactive',
  'finance.kpi.withdrawals': 'Churn',
  'finance.kpi.revenue_hint': 'Confirmed payments in the period',
  'finance.kpi.expenses_hint': 'Expenses loaded from Excel',
  'finance.kpi.net_hint': 'Revenue minus expenses',
  'finance.kpi.active_hint': 'Valid licenses',
  'finance.kpi.inactive_hint': 'Expired or inactive licenses',
  'finance.kpi.withdrawals_hint': 'Expired non-renewed + cancelled',
  'finance.kpi.food_activo_hint': 'Same Activo filter as Food Vigencias',
  'finance.kpi.food_revenue_hint': 'Sum of Active Food Vigencias plans',
  'finance.kpi.food_net_hint': 'Active-plan revenue minus expenses',
  'finance.subtitle_compact': 'Click the bars to drill down (module → program → plan → user).',
  'finance.chart.programs': 'Revenue by program',
  'finance.chart.licenses': 'Licenses by module',
  'finance.chart.trend': '12-month trend',
  'finance.chart.revenue': 'Revenue (12 months)',
  'finance.chart.mix': 'Mix by module',
  'finance.drill.title': 'Drill-down',
  'finance.expenses.title': 'Expenses (Excel)',
  'finance.expenses.help': 'Download the template, fill COP/USD amounts and upload. They reduce period net.',
  'tenants.back_list': '← Virtual gyms',
  'tenants.panel_title': 'Panel',

  'panel.d28d.cards.liveclasses.title': 'Live classes & meetings',
  'panel.d28d.cards.liveclasses.desc': 'Schedule templates and calendar with Zoom links.',
  'panel.d28d.cards.programs.title': 'Fit Live · Programs',
  'panel.d28d.cards.programs.desc': 'Cycles and settings for the 3 main programs.',
  'panel.d28d.cards.d28d-routines.title': 'Fit Live · Routines',
  'panel.d28d.cards.d28d-routines.desc': 'Routine templates for live classes and training.',
  'panel.d28d.cards.d28d-challenges-admin.title': 'Fit Live · Challenges',
  'panel.d28d.cards.d28d-challenges-admin.desc': 'Create challenges, evidence and winner podium.',
  'panel.d28d.cards.admingallery.title': 'Video gallery',
  'panel.d28d.cards.admingallery.desc': 'Exercise videos for routines and classes.',
  'panel.d28d.cards.admingyms.title': 'Gyms',
  'panel.d28d.cards.admingyms.desc': 'Branding, team and white-label setup.',
  'panel.d28d.cards.adminusers.title': 'Gym users',
  'panel.d28d.cards.adminusers.desc': 'Affiliated people management.',
  'panel.d28d.cards.d28d-trainers.title': 'Fit Live · Trainers',
  'panel.d28d.cards.d28d-trainers.desc': 'Live class hosts: routines, scheduling and Zoom. No user invite codes.',
  'panel.d28d.cards.admincompanies.title': 'Assignments',
  'panel.d28d.cards.admincompanies.desc': 'Create users, assign gym or coach, plans and invite codes.',
  'panel.d28d.cards.adminliveclasses.title': 'Live classes (gym)',
  'panel.d28d.cards.adminliveclasses.desc': 'Schedule and attendance for your gym.',
  'panel.d28d.cards.gym-masters-plans.title': 'Plans',
  'panel.d28d.cards.gym-masters-plans.desc': 'Commercial plans for your gym: pricing, programs and 28-day cycles.',

  'panel.training.cards.admintrainers.title': 'Trainers',
  'panel.training.cards.admintrainers.desc': 'Coach accounts, capacity and linked users.',

  'appearance.title': 'Appearance master',
  'appearance.subtitle': 'Images via URL or upload. Light/dark theme, brand, login, services and internal panels.',
  'appearance.loading': 'Loading appearance settings…',
  'appearance.load_error': 'Could not load configuration',
  'appearance.save_ok': 'Configuration saved.',
  'appearance.save_error': 'Error saving',
  'appearance.reset_ok': 'Default values restored.',
  'appearance.reset_error': 'Could not restore',
  'appearance.reset_confirm': 'Restore default appearance values?',
  'appearance.save': 'Save changes',
  'appearance.saving': 'Saving…',
  'appearance.reset': 'Restore defaults',
  'appearance.tab.theme': 'Theme',
  'appearance.tab.brand': 'Brand',
  'appearance.tab.auth': 'Login',
  'appearance.tab.services': 'Services',
  'appearance.tab.masters': 'Masters hub',
  'appearance.tab.programs': 'Programs',
  'appearance.tab.panels': 'Admin panels',
  'appearance.theme_title': 'Visual theme',
  'appearance.theme_hint': 'Dark: pure black background. Light: light gray background with dark cards; white and yellow text.',
  'appearance.theme_dark': 'Dark',
  'appearance.theme_light': 'Light',
  'appearance.accent': 'Accent color',
  'appearance.brand_title': 'Public brand',
  'appearance.brand_name': 'Name',
  'appearance.brand_tagline': 'Tagline',
  'appearance.logo': 'Navbar logo (URL or file)',
  'appearance.auth_title': 'Login / register',
  'appearance.auth_line_white': 'White line',
  'appearance.auth_line_y1': 'Yellow line 1',
  'appearance.auth_line_y2': 'Yellow line 2',
  'appearance.auth_subtitle': 'Subtitle',
  'appearance.auth_cta': 'Decorative button',
  'appearance.panel_select': 'Panel to edit',
  'appearance.panel_hero': 'Panel header',
  'appearance.panel_hero_img': 'Header image (optional)',
  'appearance.panel_hero_title': 'Header title',
  'appearance.panel_hero_sub': 'Header subtitle',
  'appearance.panel_no_cards': 'Save or restore defaults to see cards for this panel.',
  'appearance.card_label': 'Card: {id}',
  'appearance.img_card': 'Card image',
  'appearance.img': 'Image',
  'appearance.alt': 'Alt text',
  'appearance.card_title': 'Card title',
  'appearance.desc_user': 'Description (end user)',
  'appearance.desc_admin': 'Description (admin)',
  'appearance.desc': 'Description',
  'appearance.name': 'Name',

  'image.upload': 'Upload file',
  'image.uploading': 'Uploading…',
  'image.remove': 'Remove',
  'image.no_image': 'No image',
  'image.url_label': 'URL (external or uploaded)',
  'image.hint': 'JPG, PNG, WebP or GIF · max 5 MB. URL or file upload.',
  'image.upload_error': 'Error uploading image',
  'image.upload_no_url': 'No URL returned from server',

  'payments.title': 'Payment links by module',
  'payments.subtitle': 'super_admin only. External URLs (Mercado Pago, Stripe, etc.).',
  'payments.subtitle_programs': 'Per module (base) and optionally per active program. If a program has no own config, it uses the module one.',
  'payments.loading': 'Loading links…',
  'payments.load_error': 'Could not load payment links',
  'payments.save_error': 'Error saving',
  'payments.delete_error': 'Could not remove the program payment config',
  'payments.delete_override': 'Remove (use module)',
  'payments.active': 'Active (visible on signup when URL is set)',
  'payments.save': 'Save',
  'payments.wompi_url': 'Wompi link (online payment)',
  'payments.online_label': 'Online payment label',
  'payments.in_person_enabled': 'Enable in-person payment',
  'payments.in_person_label': 'In-person payment label',
  'payments.module_default': 'Module base configuration',
  'payments.module_default_hint': 'Used when the program has no own configuration.',
  'payments.program_overrides': 'Configuration by active program',
  'payments.add_program': 'Add program configuration',
  'payments.select_program': 'Select program…',
  'payments.create_override': 'Create configuration',
  'payments.no_more_programs': 'No more active programs without their own configuration.',

  'legal.privacy_title': 'Privacy Policy',
  'legal.terms_title': 'Terms of Service',
  'legal.accept_continue': 'Accept and Continue',

  'register.title': 'Create account',
  'register.accept_privacy': 'I accept the',
  'register.privacy_link': 'Privacy Policy',
  'register.accept_terms': 'I accept the',
  'register.terms_link': 'Terms of Service',
  'register.accept_required': 'You must accept the Privacy Policy and Terms of Service',
  'register.password_mismatch': 'Passwords do not match',
  'register.password_min': 'Password must be at least 8 characters',
  'register.gender_required': 'Please select your gender',
  'register.invite_invalid': 'Invalid code',
  'register.invite_validate_error': 'We could not validate the code',
  'register.invite_required': 'Validate your trainer or gym code first',
  'register.have_account': 'Already have an account?',
  'register.login': 'Sign in',

  'audit.title': 'Audit Dashboard',
  'audit.subtitle': 'Traceability and critical event monitoring.',
  'audit.refresh': 'Refresh',
  'audit.filter_level': 'Filter by level',
  'audit.all_levels': 'All levels',
  'audit.level_info': 'Information',
  'audit.level_warn': 'Warnings',
  'audit.level_error': 'Critical errors',
  'audit.trace_id': 'Search by Trace ID',
  'audit.trace_ph': 'e.g. ORD-12345...',
  'audit.search': 'Search',
  'audit.per_page': 'Per page',
  'audit.col_datetime': 'Date / Time',
  'audit.col_level': 'Level',
  'audit.col_event': 'Event',
  'audit.col_trace': 'Trace ID',
  'audit.col_user': 'User',
  'audit.col_message': 'Message',
  'audit.loading': 'Loading records...',
  'audit.empty': 'No audit records found.',
  'audit.user_public': 'Public',
  'audit.pagination': 'Page {page} of {totalPages} · Total: {total} records',
  'audit.no_records': 'No records',
  'audit.prev': '← Previous',
  'audit.next': 'Next →',

  'live.title': 'Live Classes',
  'live.subtitle_admin': 'Schedule templates or review the calendar filtered by program.',
  'live.subtitle_assigned': 'Your assigned program calendar.',
  'live.subtitle_user': 'Book a class and join Zoom from the calendar.',
  'live.back': '← Back',
  'live.tab_views': 'Live class views',
  'live.tab_program': 'Schedule',
  'live.tab_calendar': 'Calendar',
  'live.program_label': 'Program:',
  'live.all_programs': 'All programs',
  'live.showing': 'Showing: {label}',
  'live.your_program': 'Your program: {label}',
  'live.no_program': 'You have no assigned program yet. Talk to your coach.',
  'live.title_admin': 'Schedule live classes',
  'live.subtitle_sede': 'Global class calendar for your virtual gym (programs enabled at your branch).',
  'live.sede_programs': 'Branch programs: {count}',
  'live.sede_programs_empty': 'Programs enabled by the virtual gym.',
  'live.filter_hint': 'Use the calendar filters to find your class.',
  'live.holiday_note': 'Public holidays in Colombia may have a different schedule.',
  'live.unsaved_confirm': 'You have unsaved changes in Schedule. Switch tabs without saving?',
  'live.host_notifications': 'Notices for your classes',
  'live.host_class_readonly': 'Your assigned class (read-only)',
  'live.host_class_fallback': 'Class',
  'live.host_notice_today': 'Today',
  'live.host_notice_upcoming': 'Upcoming',
  'live.host_notice_done': 'Finished',
  'live.host_notice_start': 'Start meeting',
  'live.host_notice_join': 'Join Zoom',
  'live.host_notice_link': 'Participants link',
  'live.host_notice_copy': 'Copy',
  'live.host_notice_copied': 'Copied',
  'live.host_notice_hint': 'Open the class in the calendar to see the routine and log notes.',

  'schedule.title': 'Class schedule',
  'schedule.subtitle': 'Find your method, pick a day and enroll',
  'schedule.search_ph': 'Search by method, name or coach…',
  'schedule.search': 'Search classes',
  'schedule.filter_class_type': 'Filter by class type',
  'schedule.all_class_types': 'All class types',
  'schedule.class_type': 'Class type',
  'schedule.select_class_type': 'Select class type',
  'schedule.filter_coach': 'Filter by coach',
  'schedule.all_coaches': 'All coaches',
  'schedule.filter_day': 'Filter by day',
  'schedule.filter_date': 'Filter by date',
  'schedule.all_days': 'All days',
  'schedule.weekday.monday': 'Monday',
  'schedule.weekday.tuesday': 'Tuesday',
  'schedule.weekday.wednesday': 'Wednesday',
  'schedule.weekday.thursday': 'Thursday',
  'schedule.weekday.friday': 'Friday',
  'schedule.weekday.saturday': 'Saturday',
  'schedule.weekday.sunday': 'Sunday',
  'schedule.prev_week': 'Previous week',
  'schedule.next_week': 'Next week',
  'schedule.time_day': 'Time / Day',
  'schedule.am': 'A.M.',
  'schedule.pm': 'P.M.',
  'schedule.empty_week': 'No classes this week with the selected filters.',
  'schedule.reset_week': 'View current week',
  'schedule.week_sessions': 'Sessions this week',
  'schedule.spots': 'spots',
  'schedule.no_spots': 'No spots',
  'schedule.enroll': 'Enroll',
  'schedule.last_spot': 'Last spot!',
  'schedule.brand_line1': 'FIT LIVE',
  'schedule.brand_line2': 'PROGRAM',

  'fitness_test.abdominales': 'Crunches',
  'fitness_test.burpees': 'Burpees',
  'fitness_test.flexiones': 'Push-ups',
  'fitness_test.sentadilla': 'Squats',
  'fitness_test.plancha': 'Plank',
  'fitness_test.col_cycle': 'Cycle / Test',
  'fitness_test.col_total': 'Total',
  'fitness_test.register': 'Register',
  'fitness_test.edit': 'Edit',
  'fitness_test.modal_title': 'Record test',
  'fitness_test.modal_hint': 'Enter reps, optional weight in kg, and plank as minutes and seconds.',
  'fitness_test.weight_kg': 'Weight used (kg)',
  'fitness_test.weight_ph': 'e.g. 10',
  'fitness_test.reps_ph': 'Reps',
  'fitness_test.plancha_min': 'Plank — minutes',
  'fitness_test.plancha_sec': 'Plank — seconds',
  'fitness_test.save': 'Save result',
  'fitness_test.error': 'Error',
  'fitness_test.no_wipe': 'Cannot clear the result. Keep at least one measurement or cancel.',
  'fitness_test.need_one': 'Enter at least one measurement.',
  'fitness_test.photo_caption': 'Fitness test',
  'fitness_test.saved': 'Result saved',
  'fitness_test.save_fail': 'Could not save',
  'fitness_test.burpee_type': 'Burpee type (optional)',
  'fitness_test.burpee_any': '—',
  'fitness_test.burpee_chair': 'Chair',
  'fitness_test.burpee_mid': 'Intermediate',
  'fitness_test.burpee_full': 'Full',
  'fitness_test.photo': 'Evidence photo (optional)',
  'fitness_test.server_error': 'Could not load tests. Try again in a few seconds.',
  'fitness_test.loading': 'Loading tests…',
  'fitness_test.pending_title': 'Tests not available',
  'fitness_test.pending_hint': 'When an administrator confirms your gym payment, you can record measurements and results.',
  'fitness_test.cycle_closed_title': 'Cycle closed',
  'fitness_test.cycle_closed_hint': 'The current cycle has ended. You cannot record new measurements until the next cycle starts.',
  'fitness_test.premiacion_enrolled': 'Enrolled in challenge',
  'fitness_test.premiacion_enrolled_hint': 'You are in {name}. Upload photos in the Photos tab or check the Challenge tab.',
  'fitness_test.premiacion_not_enrolled': 'Not enrolled in challenge',
  'fitness_test.premiacion_not_enrolled_hint': 'You can enroll in {name} from the Challenge tab.',
  'fitness_test.no_test_cycle_closed': 'No test is open because the cycle is closed.',
  'fitness_test.stats_cycles': 'Cycles recorded',
  'fitness_test.stats_avg': 'Average total',
  'fitness_test.stats_best': 'Best cycle',
  'fitness_test.abdominales_hint': 'With or without weight',
  'fitness_test.burpees_hint': 'Chair / intermediate / full',

  'myaccount.wompi_hint': 'Confirming will open the Wompi checkout in a new tab.',
  'myaccount.sede_hint': 'Your coach or administrator will receive the notification and activate your subscription.',

  'support.whatsapp': 'CONTACT SUPPORT',
  'support.whatsapp_hint': 'WhatsApp will open with the message configured for your plan.',
  'support.addon.title': 'Additional services',
  'support.addon.subtitle': 'Add nutrition, training, or Fit Live · Programa as a complement to your current plan.',
  'support.addon.d28d_title': 'Fit Live · Programa',
  'support.addon.d28d_desc': 'Live classes, community, and program cycles.',
  'support.addon.food_title': 'FOOD PLAN',
  'support.addon.food_desc': 'Guided nutrition plan, food logging, and team follow-up.',
  'support.addon.training_title': 'Training',
  'support.addon.training_desc': 'Personalized routines, coach follow-up, and training progress.',
  'support.addon.loading': 'Loading additional services…',
  'support.addon.all_active': 'You already have all available complementary services active.',
  'support.addon.pick_plan': 'Plan',
  'support.addon.subscribe': 'Subscribe and pay',
  'support.addon.no_plan': 'Contact support to activate this service.',
  'support.addon.ask_whatsapp': 'Ask via WhatsApp',
  'support.addon.checkout_title': 'Subscribe to',
  'support.addon.confirm': 'Confirm',
  'support.addon.pending_title': 'Request submitted',
  'support.addon.pending_msg': 'An administrator will confirm your payment and activate the service.',
  'support.addon.pending_wompi_msg': 'Complete payment in the Wompi tab. The service activates when confirmed.',
  'support.addon.pending_food_wompi_msg': 'Complete payment on Wompi. Your trainer will activate FOOD PLAN when the money arrives.',
  'support.addon.renew_food_title': 'Renew FOOD PLAN',
  'support.addon.renew_food_note': 'Your plan expired. Complete payment; your trainer will activate FOOD PLAN when the money arrives.',
  'support.addon.food_checkout_note': 'Complete payment; your trainer will activate FOOD PLAN with the same email as this account.',
  'support.addon.wompi_url_missing': 'Wompi checkout URL was not returned. Check FOOD payment links or contact support.',
  'support.addon.success_title': 'Service subscribed',
  'support.addon.success_msg': 'Your new service will be available in a few seconds.',
  'support.addon.error_title': 'Could not subscribe',
  'support.addon.error_msg': 'Try again or contact support.',
  'support.addon.wa_food': 'Hi, I would like to subscribe to FOOD PLAN as an additional service.',
  'support.addon.wa_training': 'Hi, I would like to subscribe to the Training module as an additional service.',
  'support.addon.wa_d28d': 'Hi, I would like to subscribe to Fit Live · Programa as an additional service.',
  'support.addon.password_label': 'Your Ecosistema Fit password',
  'support.addon.password_hint': 'Same password you use to log in here',
  'support.addon.password_note': 'Your FOOD PLAN account will be created with the same email and password.',
  'support.addon.password_required': 'Enter your current password to activate FOOD PLAN with the same credentials.',
  'support.addon.subtitle_food_only': 'Get FOOD PLAN (nutrition) as a separate product alongside training with your coach.',
  'support.addon.coach_food_wompi': 'Complete payment on Wompi. Your trainer will activate FOOD PLAN when the money arrives.',
  'support.subtitle': 'Frequently asked questions and contact with your team.',
  'support.open': 'Open support',
  'support.search_faq': 'Search FAQs…',
  'support.no_faq': 'No results.',

  'home.progress_summary': 'Your progress',
  'home.open_progress': 'View my progress',
  'home.progress_cta_hint': 'Adherence, attendance, and cycle results live in My Progress.',
  'home.my_nutrition': 'Nutrition',
  'home.hero.food_cta_short': 'Daily plan →',
  'home.hero.view_food': 'View nutrition',
  'home.library_title': 'Training library',
  'home.library_hint': 'Exercise videos, recent and favorites.',
  'home.open_gallery': 'Open library',
  'home.open_recordings': 'View recordings →',
  'home.spiritual_hint': 'Devotional and spiritual content.',
  'home.support_hint': 'FAQ, assistant and WhatsApp.',
  'home.my_training': 'Training',
  'home.hero.training_cta_short': 'Routine →',
  'home.live_classes': 'Classes',
  'home.open_calendar': 'Calendar →',
  'home.view_calendar': 'View calendar',
  'home.view_progress': 'View progress',
  'home.live_classes_short': 'Live classes',
  'home.more_access': 'More shortcuts',
  'home.more_access_hint': 'Library, support and additional content',
  'home.progress_empty': 'Weekly activity',
  'home.no_progress_yet': 'Your progress will appear here once you activate a service.',
  'home.gym_virtual': 'Virtual Gym',
  'home.food_open_error': 'Could not open FOOD PLAN.',
  'home.hero.next_class': 'Your next class',
  'home.hero.today_class': "Today's priority",
  'home.enter_zoom': 'Join Zoom',
  'home.enroll_class': 'Enroll',
  'home.hero.training': 'Training',
  'home.hero.continue_training': 'Continue your routine',
  'home.routine_days_meta': '{days} day(s) assigned by your coach',
  'home.hero.start_session': 'Start session',
  'home.hero.training_done': 'Great work this week',
  'home.hero.training_meta': '{pct}% completion · {done}/{plan} sessions',
  'home.hero.nutrition': 'Nutrition',
  'home.hero.food_today': 'Your daily plan',
  'home.hero.sede_food_upsell_meta': 'Get FOOD PLAN from My Account and track your nutrition.',
  'home.hero.food_upsell_meta': 'Get FOOD PLAN with your coach and track your nutrition.',
  'home.hero.food_meta': 'Log meals and keep your nutrition progress on track.',
  'home.hero.challenge': 'Active challenge',
  'home.hero.challenge_meta': 'Upload your results and compete in the cycle.',
  'home.hero.view_challenge': 'View challenge',
  'home.hero.ascend_challenge': 'Join challenge',
  'home.hero.sede_welcome': 'Your virtual branch',
  'home.hero.sede_classes': 'Live classes and recordings',
  'home.hero.sede_meta': 'Check the calendar, enroll and review your progress.',
  'home.next_class': 'Next class',
  'home.no_upcoming_class': 'No upcoming classes scheduled',
  'home.gym_virtual_hint': 'Fit Live · Programa — check the full calendar.',
  'home.d28d_session': 'Live session',
  'home.enrolled': 'Enrolled',
  'home.active_services': 'Active services',
  'myaccount.method': 'Payment method',

  'd28d.hub.classes': 'Live classes',
  'd28d.hub.classes_hint': 'Calendar, enrollment and Zoom',
  'd28d.hub.recordings': 'Class recordings',
  'd28d.hub.recordings_hint': 'Review past sessions',
  'd28d.hub.progress': 'My progress',
  'd28d.hub.progress_hint': 'Attendance and cycle progress',
  'd28d.hub.premiacion': 'Challenge',
  'd28d.hub.premiacion_hint': 'Photos, measurements and submission',
  'd28d.hub.progress_sede_hint': 'Attendance, enrollments and recorded classes',
  'd28d.hub.subtitle_sede': 'Live classes, recordings and your progress at the branch',
  'd28d.hub.subtitle_gym': 'Everything you need for your transformation',
  'd28d.hub.subtitle': 'Everything you need for your 28-day transformation',
  'd28d.hub.whatsapp_gym_hint': 'Message us on WhatsApp whenever you need',
  'd28d.hub.whatsapp_hint': 'Contact the support team instantly',
  'd28d.hub.title': 'Your virtual gym',
  'd28d.hub.whatsapp': 'WhatsApp support',
  'd28d.hub.wa_support': 'Hi, I need support',
  'd28d.hub.wa_support_gym': 'Hi, I need support — {brand}',
  'd28d.hub.wa_support_d28d': 'Hi, I need Fit Live · Programa support',

  'd28d.cycle.load_error': 'Could not load your cycle.',
  'd28d.cycle.current': 'Active cycle',
  'd28d.cycle.day_of': 'Day {day} of {total}',
  'd28d.cycle.your_cycle': 'Your cycle',
  'd28d.cycle.days': 'days',
  'd28d.cycle.progress': 'Cycle progress',
  'd28d.cycle.ends': 'Ends',
  'd28d.cycle.remaining': 'Cycles remaining on your plan',
  'd28d.cycle.premiacion': 'Challenge',
  'd28d.cycle.start_video': 'Start video',
  'd28d.cycle.start_video_label': 'Cycle start',
  'd28d.cycle.start_video_title': 'Welcome message — {cycle}',
  'd28d.cycle.start_video_hint': 'Tap to watch the video full screen.',
  'd28d.cycle.start_video_link_hint': 'Tap to open the video.',
  'd28d.cycle.start_video_modal_title': 'Welcome — {cycle}',

  'recording.default_title': 'Recording',
  'recording.embed_fail': 'This link cannot be embedded. Open it in a new tab.',
  'recording.zoom_open_hint': 'Zoom recordings cannot play inside the app. Open them in Zoom (new tab). If Zoom asks for a passcode or says the recording is missing, check in your Zoom account that it is still shared and that the share password is correct.',
  'recording.embed_platforms': 'To play the video inside the app, use YouTube or Vimeo.',
  'recording.open_zoom': 'Open recording in Zoom',
  'recording.open_link': 'Open link',

  'spiritual.open_aria': 'Open Viento Recio',
  'spiritual.home_hint': 'Bible · Devotional · Today',

  'register.step3_title': 'Choose your plan',
  'register.no_plans': 'No active plans for this program. Contact your gym or support.',
  'register.couple_plan_badge': 'Couple plan (2 users)',

  'live.admin.confirm_delete': 'Delete this live class?',
  'live.admin.confirm_import_catalog': 'Import templates from the base catalog? (skips duplicates)',
  'live.admin.delete_error': 'Error deleting class.',

  'vigencias.extend_title': 'Extend subscription',
  'vigencias.extend_for_user': 'User',
  'vigencias.days_quick': 'Quick days',
  'vigencias.days_custom': 'Custom days',
  'vigencias.days_placeholder': 'e.g. 30',
  'vigencias.days_hint': 'Between 1 and 365 days. Added to the current plan validity.',
  'vigencias.extend_confirm': 'Extend {n} days',
  'vigencias.back_masters': 'Back to Masters',
  'vigencias.filter_all': 'All',
  'vigencias.filter_new_client': 'New',
  'vigencias.filter_old_client': 'Returning',
  'vigencias.client_new': 'New',
  'vigencias.client_old': 'Returning',
  'vigencias.col_client_type': 'Client',
  'vigencias.couple_guest': 'Couple (guest)',
  'vigencias.couple_owner': 'Couple (owner)',
  'vigencias.col_last_wa': 'Last WA',
  'vigencias.bulk_queue_hint': 'Opened 1 chat. {n} left: press «Open next» for each.',
  'vigencias.bulk_queue_status': 'WhatsApp queue {i}/{n}: {name}',
  'vigencias.bulk_queue_next': 'Open next',
  'vigencias.bulk_queue_cancel': 'Cancel queue',
  'vigencias.bulk_queue_done': 'WhatsApp queue completed.',
  'vigencias.bulk_skip_title': 'No phone',
  'vigencias.bulk_skip_phone': '{n} selected without phone were skipped.',
  'vigencias.filter_pending_payment': 'Pending payment',
  'vigencias.whatsapp_activate': 'Contact via WhatsApp',
  'vigencias.no_phone': 'No phone on file',
  'vigencias.confirm_success_title': 'Payment confirmed',
  'vigencias.confirm_success': 'Subscription active for 30 days',
  'vigencias.confirm_success_deferred': 'Payment recorded. Access will unlock when the cycle starts.',
  'vigencias.confirm_error': 'Could not confirm',
  'vigencias.reject_success_title': 'Payment rejected',
  'vigencias.reject_success': 'The user was notified',
  'vigencias.reject_error': 'Could not reject',
  'vigencias.col_user': 'User',
  'vigencias.col_module': 'Module',
  'vigencias.col_status': 'Status',
  'vigencias.col_expiry': 'Expires',
  'vigencias.col_actions': 'Actions',
  'vigencias.status_active': 'active',
  'vigencias.starts_on': 'Starts',
  'vigencias.deferred_cycle': 'Cycle from',
  'vigencias.no_license_match': 'No licenses match the filter.',
  'vigencias.search_pending': 'Search by name or email…',
  'vigencias.no_pending_match': 'No pending payment matches your search.',
  'vigencias.reject': 'Reject',
  'vigencias.admin_alerts': 'Pending payment alerts',
  'vigencias.subtitle_gym_pending_only': 'Pending payments for your gym and branches (manual activation).',
  'vigencias.subtitle_gym': 'Licences and payments for your virtual gym users.',
  'vigencias.wa_new_client': 'Hi {name}, welcome to Fit Live. Your account is registered and pending activation. Can we help you complete the process?',
  'vigencias.wa_pending_payment': 'Hi {name}, your Fit Live · Programa service is pending payment or activation. Message us if you need help enabling it.',

  'users.mark_pending_title': 'Mark pending payment',
  'users.mark_pending_hint': 'Set how many days the user has to complete payment. A reminder will be sent on the due date and you can contact them via WhatsApp.',
  'users.pending_days': 'Days to pay',
  'users.pending_due': 'Due date',
  'users.preview_whatsapp': 'WhatsApp message preview',
  'users.no_phone_whatsapp': 'This user has no phone number for WhatsApp.',
  'users.phone_hint': 'Include the country dial code to enable WhatsApp (e.g. Colombia +57).',
  'users.mark_pending_confirm': 'Mark pending',

  'd28d.recordings.empty': 'No recordings published for your program yet.',
  'd28d.recordings.open_gallery': 'Open recordings',
  'd28d.recordings.see_all': 'View all',
  'd28d.recordings.home_hint': 'Tap a class to open the recording.',
  'd28d.recordings.untitled': 'Recorded class',

  'd28d.progress.unavailable': 'Progress unavailable',
  'd28d.progress.attended': 'Attended',
  'd28d.challenges.sidebar': 'Challenges and events',
  'd28d.challenges.sidebar_hint': 'Join virtual gym events when they are active.',

  'mi_progreso.subtitle_sede': 'Your attendance, enrollments and live classes at {brand}.',
  'mi_progreso.your_gym': 'your branch',
  'mi_progreso.summary_title': 'Personal summary',
  'mi_progreso.summary_hint': 'Your weekly progress at a glance. Open each tab for details.',
  'mi_progreso.results_title': 'Your activity',
  'mi_progreso.results_hint': 'Attended (Zoom), plan days, and enrollments. Tests and photos live in their tabs.',
  'mi_progreso.results_hint_sede': 'Attended (Zoom), plan days, and enrollments. Class details are in the Classes tab.',
  'mi_progreso.tests_hint_short': 'Cycle logging and progress photos live in their tabs.',
  'mi_progreso.open_tests': 'Open tests',
  'mi_progreso.open_photos': 'Open photos',
  'mi_progreso.tab.general': 'General Progress',
  'mi_progreso.tab.alimentacion': 'Nutrition',
  'mi_progreso.tab.entrenamiento': 'Training',
  'mi_progreso.tab.clases': 'Classes',
  'mi_progreso.tab.pruebas': 'Physical tests',
  'mi_progreso.tab.premiacion': 'Challenge',
  'mi_progreso.attendance_title': 'Attendance',
  'mi_progreso.sede_attendance_hint': 'Check the class calendar, enroll and review your recordings.',
  'mi_progreso.attendance_hint': 'Summary of classes you have attended.',
  'mi_progreso.measures_training_tab_hint': 'Body measurements are in the Measurements tab, separate from your routine.',
  'mi_progreso.food_summary_hint': 'Nutrition summary in FOOD PLAN. Open the platform to log meals.',
  'mi_progreso.coach_title': 'My coach',
  'mi_progreso.connecting': 'Connecting…',

  'account.pending_title': 'Service pending activation',
  'account.pending_hint': 'For now you can only access My Account and Support. Once an administrator activates your access, classes, progress and other features will be enabled.',
  'account.pending_payment': 'Your service is pending activation. A platform or gym administrator must enable it before you can use the features.',
  'account.pending_futbol': 'Your football school is pending activation. A futbol.app or school administrator must enable it.',
  'account.pending_cycle_renewal': 'Your cycle has ended. Renew your plan to continue with the next cycle. Access is restricted until payment is confirmed.',
  'account.pending_coach_client': 'Your training is pending activation. Your coach must pay via Wompi from Activate clients before you can use the profile.',
  'account.pending_coach_hint': 'For now you can only use My Account (to purchase FOOD PLAN with Wompi) and Support. Training, library and progress unlock when your coach activates access.',
  'account.pending_coach_title': 'Welcome to {brand}',

  'myaccount.cycle_gym': 'Cycle',
  'myaccount.gym_code': 'Invitation code',
  'myaccount.gym_code_copied': 'Code copied',
  'myaccount.gym_code_hint': 'Share this code when you want to register users within the associated gym.',
  'myaccount.coach_code': 'Invitation code',
  'myaccount.coach_code_hint': 'Your coach white-label code. Share it to register training clients.',
  'myaccount.avatar_too_large': 'Image too large',
  'myaccount.avatar_max': 'Maximum 2 MB',
  'myaccount.avatar_saved': 'Profile photo updated',
  'myaccount.avatar_error': 'Could not upload photo',
  'myaccount.avatar_uploading': 'Uploading…',
  'myaccount.change_avatar': 'Change profile photo',
  'myaccount.active_services': 'Active services',
  'myaccount.current_plan': 'Current plan',
  'myaccount.renew': 'Renew',
  'myaccount.expires': 'Expires',
  'myaccount.gym': 'Branch',
  'myaccount.trainer': 'Trainer',
  'myaccount.sessions_left': 'Sessions remaining',
  'myaccount.no_active': 'You do not have an active subscription.',
  'myaccount.choose_plan': 'Choose your plan',
  'myaccount.subscribe': 'Subscribe',
  'myaccount.mydata': 'My data',
  'myaccount.birthdate': 'Date of birth',
  'myaccount.objective': 'Goal',
  'myaccount.save': 'Save changes',
  'myaccount.security': 'Security',
  'myaccount.current_password': 'Current password',
  'myaccount.new_password': 'New password',
  'myaccount.confirm_password': 'Confirm password',
  'myaccount.change_password': 'Change password',
  'myaccount.subscribe_plan': 'Subscribe to plan',
  'myaccount.confirm_and_pay': 'Confirm and pay',
  'myaccount.confirm': 'Confirm',
  'myaccount.not_available': 'N/A',

  'schedule.class_closed': 'Closed',
  'schedule.class_closed_label': 'Class closed',
  'schedule.enrollment_closed': 'Enrollment closed',
  'schedule.enrollment_closed_detail': 'This class has already ended or enrollment is not available.',
  'schedule.zoom_pending': 'The Zoom link will be available before the class.',
  'schedule.zoom_pending_trainer': 'Your trainer will publish the Zoom link before the class.',
  'schedule.enroll_fail': 'Enrollment',
  'schedule.enroll_error': 'Could not complete enrollment',
  'schedule.enroll_ok_title': 'Enrollment confirmed',
  'schedule.enroll_ok_msg': 'You are enrolled. Please join 5 minutes before class.',
  'schedule.enroll_ok_named': 'Great, you are registered for {title}. Please join 5 minutes before class — see you there.',
  'schedule.enroll_chip_note': 'Registered · join 5 min early',
  'schedule.no_zoom': 'No Zoom link',
  'schedule.enrolled': 'Enrollment confirmed',
  'schedule.no_zoom_trainer_hint': 'Your trainer has not published the link yet. Check again closer to class time.',
  'schedule.spots_available': '{count} available',
  'schedule.last_spot_suffix': ' · Last spot!',
  'schedule.default_class': 'Live class',
  'schedule.default_coach': 'Coach',
  'schedule.attendance': 'Attendance',
  'schedule.zoom_brand': 'Zoom',

  'coach.food_panel_subtitle': 'Professional FOOD PLAN panel — track your clients.',
  'myaccount.payment_wompi': 'Online payment (Wompi)',
  'myaccount.payment_sede': 'Pay at branch',

  'help.title': 'Help',
  'help.assistant_title': '{module} assistant',
  'help.placeholder': 'How can I help you?',
  'help.no_exact_match': 'I could not find an exact answer.',
  'help.contact_whatsapp': 'Contact WhatsApp support',
  'help.wa_message': 'Hi, I need help ({module}): {query}',

  'chat.title': 'Nutrition assistant',
  'chat.plan_line': 'Daily plan: {kcal} kcal · P {p}g · C {c}g · G {g}g',
  'chat.prefs': 'Preferences',
  'chat.hide_prefs': 'Hide prefs',
  'chat.open': 'Open nutrition assistant',
  'chat.placeholder': 'Type your question...',
  'chat.send': 'Send',
  'chat.prefs_saved': 'Preferences saved.',
  'chat.close': 'Close',
  'chat.assistant_btn': 'Assistant',
  'chat.save_prefs': 'Save preferences',
  'appearance.lang_es': 'Spanish (ES)',
  'appearance.lang_en': 'English (EN)',
};
